import { ChartDesignerActionTypes } from './constants';
import { findNewObjects, renameDuplicate, uniqueNameForObject } from '../../utils/renameDuplicate';
import { v4 as uuid } from 'uuid';

interface State {
    chartId: any | "",
    config?: any | {};
    allFieldList: any[],
    fieldList: any[],
    newFieldList: any[],
    boadList: any[],
    shaxesList: any[],
    conditionList: any[],
    cond: any[],
    groupesList: any[],
    gaugeItemList: any[],
    scatterItemList: any[],
    alarms:any[]
}

const INIT_STATE = {
    chartId: "",
    allFieldList: [],
    fieldList: [],
    newFieldList: [],
    boadList: [],
    shaxesList: [],
    conditionList: [],
    cond: [],
    groupesList: [],
    gaugeItemList: [],
    scatterItemList: [],
    alarms:[],

    colorPallet: {
        colors: "[\"#e99958\",\"#eaca58\",\"#97d749\",\"#4ad658\",\"#44dcb4\",\"#5eb9c2\",\"#4593db\",\"#2266ff\",\"#4a51d6\",\"#7e21ff\",\"#9144bb\",\"#bb44cc\",\"#cc5588\",\"#ee99bb\",\"#ee7692\"]",
        id: "c891bf9b-462a-ee11-afdb-08606e00ebaa",
    },

    config: {
        seriesField: 'series',
        isGroup: true,
        isStack: false,

        sanjabProp: {
            measure: 'value',
            //dimension: '',
            chartType: "Column",
            chartMapType: "Iran",
            // chartGaugeType: "grafana",

            isSorting: false,
            isConditionally: false,
            isAlarm: false,
            isDrillTrogh: {
                chart: false,
                boad: false,
                series: false
            },
            chartDrillTroghPageId: '',
            isDrill: true,
            isSlider: false,
            isChangeShaxes: false,
            currentShaxesId: '',
            currentBoadId: '',
            cond: '',
            filterList: [
                // {
                //     id:"",
                //     operatorName: "in",
                //     filterArray: [],
                //     filterCol: ""
                // }
            ],
            drillList: {},

            label: {
                position: 'middle',
                autoRotate: true,
                autoHide: true
            },
        },

        publicSettings: {
            activeKey: undefined,

            spublic: {
                isVisible: false,
                isGradantHeapMap: false
            },

            legend: {
                isVisible: false,
                layout: 'vertical',
                position: 'top-right'
            },

            labelOnChart: {
                isVisible: false,
                open: false,
                position: 'top',
                isTotalShow: false,
                isMatchColorWithArc: true,
                fontFamily: 'IRANSans',
                fontZaryb: '1',
                fontFormat: {
                    format: '1',
                    decimal: '0',
                    separator: true
                },
                fontSize: 12,
                fontWeight: '600',
                fontStyle: 'normal',
                textAlign: 'center',
                color: '#000000',
                backgroundColor: 'transparent',
                rotate: 0
            },

            tooltip: {
                isVisible: true,
                isShared: true,
                isFollow: true,
                style: {
                    tooltip: {
                        open: false,
                        backgroundColor: 'rgba(0, 0, 0, 0.84)',
                        fontFamily: 'IRANSans',
                        fontZaryb: '1',
                        fontSize: 12,
                        fontFormat: {
                            format: '1',
                            decimal: '0',
                            separator: true
                        },
                        fontColor: 'rgb(255, 255, 255)',
                        fontWeight: '400',
                        fontStyle: 'normal',
                        textAlign: 'left',
                    }
                }
            },

            gridLine: {
                isVisible: true,
                xAxis: {
                    isVisible: false,
                    isAlignTick: true,
                    stroke: '#535252',
                    lineWidth: 0.3,
                    isLineDash: true,
                    strokeOpacity: 0.4
                },
                yAxis: {
                    isVisible: true,
                    isAlignTick: true,
                    stroke: '#535252',
                    lineWidth: 0.3,
                    isLineDash: true,
                    strokeOpacity: 0.4
                },
            },

            widget: {
                isVisible: true,
                icon: {
                    name: "comment-chart-line",
                    color: '#27ae60',
                    size: '32',
                    isFill: false,
                },
                style: {
                    backgroundColor: 'white',

                    textLabel: {
                        open: false,
                        fontFamily: 'IRANSans',
                        fontZaryb: '1',
                        fontSize: 14,
                        fontFormat: {
                            format: '1',
                            decimal: '0',
                            separator: true
                        },
                        fontColor: 'rgb(89, 89, 89)',
                        fontWeight: '400',
                        fontStyle: 'normal',
                        textAlign: 'center'
                    },

                    valueLabel: {
                        open: false,
                        fontFamily: 'IRANSans',
                        fontZaryb: '1',
                        fontSize: 14,
                        fontFormat: {
                            format: '1',
                            decimal: '0',
                            separator: true
                        },
                        fontColor: 'rgb(89, 89, 89)',
                        fontWeight: '400',
                        fontStyle: 'normal',
                        textAlign: 'center'
                    }
                },
            },

            textChart: {
                isVisible: true,

                style: {
                    backgroundColor: 'white'
                },
                title: {
                    isVisible: true,
                    content: 'عنوان',
                    style: {
                        open: false,
                        fontFamily: 'IRANSans',
                        fontZaryb: '1',
                        fontSize: 15,
                        fontFormat: {
                            format: '1',
                            decimal: '0',
                            separator: true
                        },
                        fontColor: 'rgb(89, 89, 89)',
                        fontWeight: 'bold',
                        fontStyle: 'normal',
                        textAlign: 'center'
                    },
                },
                subTitle: {
                    isVisible: true,
                    content: 'عنوان فرعی',
                    style: {
                        open: false,
                        fontFamily: 'IRANSans',
                        fontZaryb: '1',
                        fontSize: 14,
                        fontFormat: {
                            format: '1',
                            decimal: '0',
                            separator: true
                        },
                        fontColor: 'rgb(89, 89, 89)',
                        fontWeight: '400',
                        fontStyle: 'normal',
                        textAlign: 'center'
                    },
                }
            },

            funnel: {
                isVisible: true,
                isTransposed: false,
                dynamicHeight: false,
                conversionTag: false
            },

            tableStyle: {
                heatmapMode: '0',
                isRepeatKeysInGroups: false,
                isShowTotal: false,
                isShowTotalColumn: false,
                isShowSort: false,
                isShowFilter: false,

                open: false,
                fontFamily: 'IRANSans',
                fontZaryb: '1',
                fontFormat: {
                    format: '1',
                    decimal: '0',
                    separator: true
                },
                fontSize: 12,
                fontWeight: '400',
                fontStyle: 'normal',
                textAlign: 'center',
                color: '#4b4b5a',
                tableSumCellStyle: {
                    open: false,
                    fontFamily: 'IRANSans',
                    fontZaryb: '1',
                    fontFormat: {
                        format: '1',
                        decimal: '0',
                        separator: true
                    },
                    fontSize: 12,
                    fontWeight: '400',
                    fontStyle: 'normal',
                    textAlign: 'center',
                    color: '#4b4b5a',
                },
                tableSumCellStyleColumn: {
                    open: false,
                    fontFamily: 'IRANSans',
                    fontZaryb: '1',
                    fontFormat: {
                        format: '1',
                        decimal: '0',
                        separator: true
                    },
                    fontSize: 12,
                    fontWeight: '400',
                    fontStyle: 'normal',
                    textAlign: 'center',
                    color: '#4b4b5a',
                },
            },

            gauge: {
                viewLabelType: "1",
                chartGaugeType: "grafana",
                pointerType: "needle",
                isGradient: false,
                isUsePalletColor: false,
                isMetric: false,
                isPaddingInRange: true,

                minValue: {
                    default: 0,
                    fieldName: '',
                    selectPercent: '0',
                    tooltip: { text: 'حد پایین' }
                },
                maxValue: {
                    default: 100,
                    fieldName: '',
                    color: '#27ae60',
                    isShowInGauge: false,
                    selectPercent: '0',
                    tooltip: { text: 'حد بالا' }
                },
                range: [],
                rangeStyle: {
                    open: false,
                    fontFamily: 'IRANSans',
                    fontZaryb: '1',
                    fontSize: 12,
                    fontFormat: {
                        format: '1',
                        decimal: '0',
                        separator: true
                    },
                    fontColor: 'rgb(89, 89, 89)',
                    fontWeight: 'normal',
                    fontStyle: 'normal',
                    textAlign: 'center'
                },
            },

            scatter: {
                shape: 'circle',
                colorField: '',
                sizeField: '',
                xFieldScatter: '',
            },

            line: {
                lineX: {
                    autoHide: true,
                    autoRotate: true,
                    isScroll: true,
                    isSlider: false,
                    minLimit: undefined,
                    maxLimit: undefined,
                    range: [],
                    style: {
                        open: false,
                        //backgroundColor: 'transparent',
                        fontFamily: 'IRANSans',
                        fontZaryb: '1',
                        fontSize: 12,
                        fontFormat: {
                            format: '1',
                            decimal: '0',
                            separator: false
                        },
                        fontColor: 'rgb(51, 51, 51)',
                        fontWeight: '400',
                        fontStyle: 'normal',
                        textAlign: 'center',
                    }
                },
                lineY: {
                    autoHide: true,
                    autoRotate: true,
                    isScroll: true,
                    minLimit: undefined,
                    maxLimit: undefined,
                    range: [],
                    style: {
                        open: false,
                        //backgroundColor: 'transparent',
                        fontFamily: 'IRANSans',
                        fontZaryb: '1',
                        fontSize: 12,
                        fontFormat: {
                            format: '1',
                            decimal: '0',
                            separator: false
                        },
                        fontColor: 'rgb(51, 51, 51)',
                        fontWeight: '400',
                        fontStyle: 'normal',
                        textAlign: 'right',
                    }
                },
                lineY2: {
                    isVisible: true,
                    autoHide: true,
                    autoRotate: true,
                    isScroll: true,
                    minLimit: undefined,
                    maxLimit: undefined,
                    style: {
                        open: false,
                        //backgroundColor: 'transparent',
                        fontFamily: 'IRANSans',
                        fontZaryb: '1',
                        fontSize: 12,
                        fontFormat: {
                            format: '1',
                            decimal: '0',
                            separator: false
                        },
                        fontColor: 'rgb(51, 51, 51)',
                        fontWeight: '400',
                        fontStyle: 'normal',
                        textAlign: 'left',
                    }
                },
            },

            map: {
                chartMapType: "Iran",
                isZoom: false,
            },

            pie: {
                type: '1',
                isPercent: false,
                isShowValue: true,
                showTotal: {
                    isVisible: false,
                    style: {
                        open: false,
                        fontFamily: 'IRANSans',
                        fontZaryb: '1',
                        fontSize: 20,
                        fontFormat: {
                            format: '1',
                            decimal: '0',
                            separator: true
                        },
                        fontColor: 'rgb(89, 89, 89)',
                        fontWeight: 'bold',
                        fontStyle: 'normal',
                        textAlign: 'center'
                    },
                },
            },

            pics: {
                filePath: ''
            },

            lineArea: {
                isSmooth: true,
                isSheklOnShekast: true,
                sheklOnShekast: 'circle'
            },

            rangeMarker: {
                range: [],
                marker: [],
            },


        },

        shaxesSettings: {
            activeKey: undefined,
            mohasebat: {},
            design: {
                color: '',
            }
        }
    },
};

const ChartDesign = (state: State = INIT_STATE, action: any): any => {
    switch (action.type) {
        case ChartDesignerActionTypes.CHANGE_MAPTYPE:
            return {
                ...state,
                // chartType: cc,
                config: { ...state.config, sanjabProp: { ...state.config.sanjabProp, chartMapType: action.payload } }
            };




        case ChartDesignerActionTypes.CHANGE_CHART_DRILL:
            return {
                ...state,
                config: {
                    ...state.config
                    , sanjabProp: {
                        ...state.config.sanjabProp, isDrill: action.payload
                        // ,dimension: !action.payload ? 'dor' : state.boadList.length > 0 && _.lowerFirst(state.boadList[0].name),

                    }
                }
            };

        case ChartDesignerActionTypes.CHANGE_DRILLVALUE:
            const { charts, data } = action.payload
            return {
                ...state,
                config: { ...state.config, sanjabProp: { ...state.config.sanjabProp, drillList: action.payload } }
            };



        case ChartDesignerActionTypes.CHANGE_CHARTTYPE:
            let chartType = action.payload.chartType
            let IsStack = action.payload.isStack
            let IsGroup = action.payload.isGroup
            let s_IsDrill = state.config.sanjabProp.isDrill

            return {
                ...state,
                config: { ...state.config, isStack: IsStack, isGroup: IsGroup, sanjabProp: { ...state.config.sanjabProp, chartType: chartType, isDrill: chartType === 'Tree' || chartType === 'Text' || chartType === 'Widget' || chartType === 'Map' ? false : s_IsDrill }, publicSettings: { ...state.config?.publicSettings, labelOnChart: { ...state.config?.publicSettings.labelOnChart, isTotalShow: false, isMatchColorWithArc: true } } }
            };

        case ChartDesignerActionTypes.CHANGE_CHARTCOLORPALLET:
            return {
                ...state,
                colorPallet: { ...state.config.colorPallet, colors: action.payload.colors, id: action.payload.id }
            };

        case ChartDesignerActionTypes.CHANGE_CHARTID:
            return {
                ...state,
                chartId: action.payload,
            };

        case ChartDesignerActionTypes.CHANGE_FIELD:
            var tFNF = [...action.payload.map((f: any) => ({ ...f, isNewField: false })), ...state.newFieldList.map((f: any) => ({ ...f, isNewField: true }))];
            return {
                ...state,
                fieldList: tFNF,
                allFieldList: tFNF,
            };

        case ChartDesignerActionTypes.CHANGE_BOAD:
            var t1 = state.boadList;
            if (action.payload.length > state.boadList.length) {
                if (action.payload.length === state.boadList.length + 1) {
                    const addedBoad = findNewObjects(state.boadList, action.payload)
                    if (addedBoad) {
                        const addedBoaedUniq = uniqueNameForObject(addedBoad[0], [...state.boadList, ...state.shaxesList])
                        const dt = action.payload.findIndex((x: any) => x.id === addedBoaedUniq.id)
                        if (dt !== -1) {
                            action.payload[dt].UniqueName = addedBoaedUniq.UniqueName
                        }
                        //t1 = [...state.boadList, addedBoaedUniq]action.payload                       
                        t1 = action.payload

                    }
                }
                else {
                    t1 = action.payload
                }
            }
            else
                t1 = action.payload


            // var t1 = renameDuplicate([...action.payload, ...state.shaxesList]);
            return {
                ...state,
                boadList: t1,
                config: {
                    ...state.config,
                    // sanjabProp: { ...state.config.sanjabProp, dimension: action.payload.length > 0 && _.lowerFirst(action.payload[0].name), isDrill: action.payload.length === 1 ? false : state.config.sanjabProp.isDrill }
                    sanjabProp: { ...state.config.sanjabProp, currentBoadId: t1[0]?.id }

                }
            };

        case ChartDesignerActionTypes.CHANGE_SHAXES:
            var tShaxes = state.shaxesList;
            if (action.payload.length > state.shaxesList.length) {
                if (action.payload.length === state.shaxesList.length + 1) {

                    const addedShaxes = findNewObjects(state.shaxesList, action.payload)
                    if (addedShaxes) {
                        const addedShaxesUniq = uniqueNameForObject(addedShaxes[0], [...state.boadList, ...state.shaxesList])
                        const dts = action.payload.findIndex((x: any) => x.id === addedShaxesUniq.id)
                        if (dts !== -1) {
                            action.payload[dts].UniqueName = addedShaxesUniq.UniqueName
                        }
                        //t1 = [...state.boadList, addedBoaedUniq]action.payload                      
                        tShaxes = action.payload
                    }
                }
                else {
                    tShaxes = action.payload
                }
            }
            else
                tShaxes = action.payload

            //var tShaxes = renameDuplicate(action.payload);
            // var tShaxes = renameDuplicate([...action.payload, ...state.boadList]);

            //var t1=action.payload;
            return {
                ...state,
                shaxesList: tShaxes,
                config: {
                    ...state.config,
                    //sanjabProp: { ...state.config.sanjabProp, measure: _.lowerFirst(t1[0].UniqueName), currentShaxesId: t1[0].id }
                    sanjabProp: { ...state.config.sanjabProp, currentShaxesId: tShaxes[0]?.id }
                    , publicSettings: { ...state.config.publicSettings, spublic: { ...state.config.publicSettings.spublic, isGradantHeapMap: tShaxes.length > 1 ? false : state.config.publicSettings.spublic.isGradantHeapMap } }
                }
            };

        case ChartDesignerActionTypes.CHANGE_CURRENTSHAXESID:
            return {
                ...state,
                config: {
                    ...state.config,
                    sanjabProp: { ...state.config.sanjabProp, currentShaxesId: action.payload }
                }
            };

        case ChartDesignerActionTypes.CHANGE_CURRENTBOADID:
            return {
                ...state,
                config: {
                    ...state.config,
                    sanjabProp: { ...state.config.sanjabProp, currentBoadId: action.payload }
                }
            };

        case ChartDesignerActionTypes.CHANGE_NEWFIELD:
            const aNewFields = action?.payload?.map((f: any) => ({ ...f, isNewField: true, id: uuid() }))
            let taFieldList = [...state.fieldList, ...aNewFields]
            return {
                ...state,
                newFieldList: aNewFields,
                fieldList: taFieldList,
                allFieldList: taFieldList
            };

        case ChartDesignerActionTypes.CHANGE_ADDNEWFIELD:
            const addedNewField = action.payload
            const s_addnewFieldList = state.newFieldList;
            const s_addfieldList = state.fieldList;
            let tNewFields: any = []
            let tFieldList: any = []
            const s_newFieldListIndex = s_addnewFieldList.findIndex((f: any) => f?.id === addedNewField?.id)
            if (s_newFieldListIndex !== -1) {
                s_addnewFieldList[s_newFieldListIndex].name = addedNewField.name
                s_addnewFieldList[s_newFieldListIndex].type = addedNewField.type
                s_addnewFieldList[s_newFieldListIndex].length = addedNewField.length
                s_addnewFieldList[s_newFieldListIndex].expression = addedNewField.expression

                tNewFields = s_addnewFieldList
            }

            else {
                tNewFields = [...s_addnewFieldList, addedNewField]
            }
            const s_fieldListIndex = s_addfieldList.findIndex((f: any) => f?.id === addedNewField?.id)
            if (s_fieldListIndex !== -1) {
                s_addfieldList[s_fieldListIndex].name = addedNewField.name
                s_addfieldList[s_fieldListIndex].type = addedNewField.type
                s_addfieldList[s_fieldListIndex].length = addedNewField.length
                s_addfieldList[s_fieldListIndex].expression = addedNewField.expression

                tFieldList = s_addfieldList
            }
            else {
                tFieldList = [...s_addfieldList, addedNewField]

            }

            //let tNewFields = [...s_newFieldList, addedNewField]
            //let tFieldList = [...s_fieldList, addedNewField]

            return {
                ...state,
                newFieldList: tNewFields,
                fieldList: tFieldList,
                allFieldList: tFieldList
            };

        case ChartDesignerActionTypes.CHANGE_DELETENEWFIELD:
            const deleteddNewField = action.payload
            let dn = state.newFieldList
            let d = state.fieldList
            let tDeleteFields = dn.filter((f: any) => f?.id !== deleteddNewField?.id)
            let tFieldList1 = d.filter((f: any) => f?.id !== deleteddNewField?.id)

            //let tFieldList1 = [...state.fieldList, ...tDeleteFields]

            return {
                ...state,
                newFieldList: tDeleteFields,
                fieldList: tFieldList1,
                allFieldList: tFieldList1
            };



        case ChartDesignerActionTypes.CHANGE_SHAXES_UNIQNAME:
            const isUniqNameChange = state.config.sanjabProp.isChangeShaxes
            const indexUniqName = state.shaxesList.findIndex(object => { return object.id === action.payload.id })
            const s_shaxesUniqName = state.shaxesList;
            if (indexUniqName !== -1) {
                s_shaxesUniqName[indexUniqName].UniqueName = action.payload.UniqueName;
            }

            return {
                ...state,
                shaxesList: s_shaxesUniqName,
                config: {
                    ...state.config,
                    sanjabProp: { ...state.config.sanjabProp, isChangeShaxes: !isUniqNameChange, currentShaxesId: action.payload.id }
                }
            };

        case ChartDesignerActionTypes.CHANGE_BOAD_UNIQNAME:
            const isBUniqNameChange = state.config.sanjabProp.isChangeShaxes
            const indexBUniqName = state.boadList.findIndex(object => { return object.id === action.payload.id })
            const s_boadUniqName = state.boadList;
            if (indexBUniqName !== -1) {
                s_boadUniqName[indexBUniqName].UniqueName = action.payload.UniqueName;
            }

            return {
                ...state,
                boadList: s_boadUniqName,
                config: {
                    ...state.config,
                    sanjabProp: { ...state.config.sanjabProp, isChangeShaxes: !isBUniqNameChange, currentBoadId: action.payload.id }
                }
            };



        case ChartDesignerActionTypes.CHANGE_SHAXES_AGGREGATION:
            let s_activeKey33 = state.config.publicSettings.activeKey

            if (action.payload.activeKey !== undefined) {
                s_activeKey33 = action.payload.activeKey
            }
            const isAgChange = state.config.sanjabProp.isChangeShaxes
            const index = state.shaxesList.findIndex(object => { return object.id === action.payload.id })
            const s_shaxes = state.shaxesList;
            if (index !== -1) {
                s_shaxes[index].aggregation = action.payload.aggregation;
            }
            var t = renameDuplicate(s_shaxes);

            return {
                ...state,
                shaxesList: t,
                config: {
                    ...state.config,
                    sanjabProp: { ...state.config.sanjabProp, isChangeShaxes: !isAgChange, currentShaxesId: action.payload.id },
                    shaxesSettings: { ...state.config.shaxesSettings, activeKey: s_activeKey33 }
                }
            };


        case ChartDesignerActionTypes.CHANGE_SHAXES_CALCULATETYPE:
            let s_activeKeyCal = state.config.publicSettings.activeKey

            if (action.payload.activeKey !== undefined) {
                s_activeKeyCal = action.payload.activeKey
            }
            const s_isChangeShaxes = state.config.sanjabProp.isChangeShaxes
            const s_index = state.shaxesList.findIndex(object => { return object.id === action.payload.id })
            const s_shaxesCal = state.shaxesList;
            if (s_index !== -1) {
                s_shaxesCal[s_index].calculateType = action.payload.calculateType;
            }
            var tShaxesCal = renameDuplicate(s_shaxesCal);

            return {
                ...state,
                shaxesList: tShaxesCal,
                config: {
                    ...state.config,
                    sanjabProp: { ...state.config.sanjabProp, isChangeShaxes: !s_isChangeShaxes, currentShaxesId: action.payload.id },
                    shaxesSettings: { ...state.config.shaxesSettings, activeKey: s_activeKeyCal }
                }
            };

        case ChartDesignerActionTypes.CHANGE_SHAXES_CHARTTYPE:
            let s_activeKeyCharttype = state.config.publicSettings.activeKey

            if (action.payload.activeKey !== undefined) {
                s_activeKeyCharttype = action.payload.activeKey
            }
            const s_isChangeShaxesChartType = state.config.sanjabProp.isChangeShaxes
            const s_indexChartType = state.shaxesList.findIndex(object => { return object.id === action.payload.id })
            const s_shaxesChartType = state.shaxesList;
            if (s_indexChartType !== -1) {
                s_shaxesChartType[s_indexChartType].chartType = action.payload.chartType;
            }
            var tShaxesCharttype = renameDuplicate(s_shaxesChartType);

            return {
                ...state,
                shaxesList: tShaxesCharttype,
                config: {
                    ...state.config,
                    sanjabProp: { ...state.config.sanjabProp, isChangeShaxes: !s_isChangeShaxesChartType, currentShaxesId: action.payload.id },
                    shaxesSettings: { ...state.config.shaxesSettings, activeKey: s_activeKeyCharttype }
                }
            };




        case ChartDesignerActionTypes.CHANGE_SHAXES_ISNOTNULLAGREGATION:
            let s_activeKeyNotNullAggregation = state.config.publicSettings.activeKey

            if (action.payload.activeKey !== undefined) {
                s_activeKeyNotNullAggregation = action.payload.activeKey
            }
            const isNotNullAgChange = state.config.sanjabProp.isChangeShaxes
            const indexNN = state.shaxesList.findIndex(object => { return object.id === action.payload.id })
            const s_shaxesNN = state.shaxesList;
            if (indexNN !== -1) {
                s_shaxesNN[indexNN].isNotNullAggregation = action.payload.isNotNullAggregation;
            }
            var t22 = renameDuplicate(s_shaxesNN);

            return {
                ...state,
                shaxesList: t22,
                config: {
                    ...state.config,
                    sanjabProp: { ...state.config.sanjabProp, isChangeShaxes: !isNotNullAgChange, currentShaxesId: action.payload.id },
                    shaxesSettings: { ...state.config.shaxesSettings, activeKey: s_activeKeyNotNullAggregation }
                }
            };

        case ChartDesignerActionTypes.CHANGE_SHAXES_NONEVALUETYPEAGREGATION:
            let s_activeKeyNoneValueTypeAggregation = state.config.publicSettings.activeKey

            if (action.payload.activeKey !== undefined) {
                s_activeKeyNoneValueTypeAggregation = action.payload.activeKey
            }
            const isNoneValueTypeAgChange = state.config.sanjabProp.isChangeShaxes
            const indexNNV = state.shaxesList.findIndex(object => { return object.id === action.payload.id })
            const s_shaxesNNV = state.shaxesList;
            if (indexNNV !== -1) {
                s_shaxesNNV[indexNNV].noneValueType = action.payload.noneValueType;
            }
            var t22 = renameDuplicate(s_shaxesNNV);

            return {
                ...state,
                shaxesList: t22,
                config: {
                    ...state.config,
                    sanjabProp: { ...state.config.sanjabProp, isChangeShaxes: !isNoneValueTypeAgChange, currentShaxesId: action.payload.id },
                    shaxesSettings: { ...state.config.shaxesSettings, activeKey: s_activeKeyNoneValueTypeAggregation }
                }
            };


        case ChartDesignerActionTypes.CHANGE_SHAXES_HEATMAPMODE:
            let s_activeKeyHeat = state.config.publicSettings.activeKey

            if (action.payload.activeKey !== undefined) {
                s_activeKeyHeat = action.payload.activeKey
            }
            const s_isChangeShaxesH = state.config.sanjabProp.isChangeShaxes
            const s_indexH = state.shaxesList.findIndex(object => { return object.id === action.payload.id })
            const s_shaxesCalH = state.shaxesList;
            if (s_indexH !== -1) {
                s_shaxesCalH[s_indexH].heatmapMode = action.payload.heatmapMode;
            }
            var tShaxesHeatMap = renameDuplicate(s_shaxesCalH);

            return {
                ...state,
                shaxesList: tShaxesHeatMap,
                config: {
                    ...state.config,
                    sanjabProp: { ...state.config.sanjabProp, isChangeShaxes: !s_isChangeShaxesH, currentShaxesId: action.payload.id },
                    shaxesSettings: { ...state.config.shaxesSettings, activeKey: s_activeKeyHeat }
                }
            };

        case ChartDesignerActionTypes.CHANGE_SHAXES_ISSHOWTOTAL:
            let s_activeKeyIsShowTotal = state.config.publicSettings.activeKey

            if (action.payload.activeKey !== undefined) {
                s_activeKeyIsShowTotal = action.payload.activeKey
            }
            const s_isChangeShaxesTotal = state.config.sanjabProp.isChangeShaxes
            const s_indexTotal = state.shaxesList.findIndex(object => { return object.id === action.payload.id })
            const s_shaxesCalTotal = state.shaxesList;
            if (s_indexTotal !== -1) {
                s_shaxesCalTotal[s_indexTotal].isShowTotal = action.payload.isShowTotal;
            }
            var tShaxesTotal = renameDuplicate(s_shaxesCalTotal);

            return {
                ...state,
                shaxesList: tShaxesTotal,
                config: {
                    ...state.config,
                    sanjabProp: { ...state.config.sanjabProp, isChangeShaxes: !s_isChangeShaxesTotal, currentShaxesId: action.payload.id },
                    shaxesSettings: { ...state.config.shaxesSettings, activeKey: s_activeKeyIsShowTotal }
                }
            };

        case ChartDesignerActionTypes.CHANGE_SHAXES_HEATMAPCOLOR:
            let s_activeKeyHeatColor = state.config.publicSettings.activeKey

            if (action.payload.activeKey !== undefined) {
                s_activeKeyHeatColor = action.payload.activeKey
            }
            const s_isChangeShaxesHC = state.config.sanjabProp.isChangeShaxes
            const s_indexHC = state.shaxesList.findIndex(object => { return object.id === action.payload.id })
            const s_shaxesCalHC = state.shaxesList;
            if (s_indexHC !== -1) {
                s_shaxesCalHC[s_indexHC].heatmapColor = action.payload.heatmapColor;
            }
            var tShaxesHeatMap = renameDuplicate(s_shaxesCalHC);

            return {
                ...state,
                shaxesList: tShaxesHeatMap,
                config: {
                    ...state.config,
                    sanjabProp: { ...state.config.sanjabProp, isChangeShaxes: !s_isChangeShaxesHC, currentShaxesId: action.payload.id },
                    shaxesSettings: { ...state.config.shaxesSettings, activeKey: s_activeKeyHeatColor }
                }
            };

        case ChartDesignerActionTypes.CHANGE_SHAXES_HEATMAPCOLOR2:
            let s_activeKeyHeatColor2 = state.config.publicSettings.activeKey

            if (action.payload.activeKey !== undefined) {
                s_activeKeyHeatColor2 = action.payload.activeKey
            }
            const s_isChangeShaxesHC2 = state.config.sanjabProp.isChangeShaxes
            const s_indexHC2 = state.shaxesList.findIndex(object => { return object.id === action.payload.id })
            const s_shaxesCalHC2 = state.shaxesList;
            if (s_indexHC2 !== -1) {
                s_shaxesCalHC2[s_indexHC2].heatmapColor2 = action.payload.heatmapColor2;
            }
            var tShaxesHeatMap2 = renameDuplicate(s_shaxesCalHC2);

            return {
                ...state,
                shaxesList: tShaxesHeatMap2,
                config: {
                    ...state.config,
                    sanjabProp: { ...state.config.sanjabProp, isChangeShaxes: !s_isChangeShaxesHC2, currentShaxesId: action.payload.id },
                    shaxesSettings: { ...state.config.shaxesSettings, activeKey: s_activeKeyHeatColor2 }
                }
            };

        case ChartDesignerActionTypes.CHANGE_SHAXES_DESIGN:
            let s_activeKey2 = state.config.publicSettings.activeKey

            if (action.payload.activeKey !== undefined) {
                s_activeKey2 = action.payload.activeKey
            }
            const isAgChange2 = state.config.sanjabProp.isChangeShaxes
            const index2 = state.shaxesList.findIndex(object => { return object.id === action.payload.id })
            const s_shaxes2 = state.shaxesList;
            if (index2 !== -1) {
                s_shaxes2[index2].detail = { ...s_shaxes2[index2].detail, color: action.payload.color };
            }
            //var t = renameDuplicate(s_shaxes2);

            return {
                ...state,
                shaxesList: s_shaxes2,
                config: {
                    ...state.config,
                    sanjabProp: { ...state.config.sanjabProp, isChangeShaxes: !isAgChange2, currentShaxesId: action.payload.id },
                    shaxesSettings: { ...state.config.shaxesSettings, activeKey: s_activeKey2 }
                }
            };


        case ChartDesignerActionTypes.CHANGE_CONDOTION:
            return {
                ...state,
                conditionList: renameDuplicate(action.payload),
            };

        case ChartDesignerActionTypes.CHANGE_GROUPES:
            return {
                ...state,
                groupesList: renameDuplicate(action.payload),
                config: {
                    ...state.config,
                    publicSettings: { ...state.config.publicSettings, spublic: { ...state.config.publicSettings.spublic, isGradantHeapMap: action.payload?.length > 0 ? false : state.config.publicSettings.spublic.isGradantHeapMap } }
                }


            };



        case ChartDesignerActionTypes.CHANGE_SEARCH_VALUE:
            if (action.payload === '') {
                return { ...state, fieldList: state.allFieldList };
            }
            const searchItems = state.allFieldList.filter((item: any) => item.name.toLowerCase().includes(action.payload))
            return {
                ...state,
                fieldList: searchItems,
            };

        case ChartDesignerActionTypes.CHANGE_RESET_INITIAL_STATE:
            return {
                ...INIT_STATE,
            };

        case ChartDesignerActionTypes.CHANGE_ACTIVEKEY_PUBLICSETTINGS:
            return {
                ...state,

                config: {
                    ...state.config,
                    publicSettings: { ...state.config.publicSettings, activeKey: action.payload }
                }
            };

        case ChartDesignerActionTypes.CHANGE_CHART_PUBLIC:
            let piblicVisible = state.config.publicSettings.spublic.isVisible
            let isGradantHeapMap = state.config.publicSettings.spublic.isGradantHeapMap
            let p_activeKey = state.config.publicSettings.activeKey

            if (action.payload.activeKey !== undefined) {
                p_activeKey = action.payload.activeKey
            }

            if (action.payload.isVisible !== undefined) {
                piblicVisible = action.payload.isVisible
            }

            if (action.payload.isGradantHeapMap !== undefined)
                isGradantHeapMap = action.payload.isGradantHeapMap

            return {
                ...state,
                config: {
                    ...state.config,
                    publicSettings: { ...state.config.publicSettings, activeKey: p_activeKey, spublic: { ...state.config.publicSettings.spublic, isVisible: piblicVisible, isGradantHeapMap: isGradantHeapMap } }
                }
            };



        case ChartDesignerActionTypes.CHANGE_CHART_LEGEND:
            let legendVisible = state.config.publicSettings.legend.isVisible
            let legendPosition = state.config.publicSettings.legend.position
            let s_activeKey = state.config.publicSettings.activeKey

            if (action.payload.activeKey !== undefined) {
                s_activeKey = action.payload.activeKey
            }

            if (action.payload.isVisible !== undefined) {
                legendVisible = action.payload.isVisible
            }

            if (action.payload.position !== undefined)
                legendPosition = action.payload.position

            return {
                ...state,
                config: {
                    ...state.config,
                    publicSettings: { ...state.config.publicSettings, activeKey: s_activeKey, legend: { ...state.config.publicSettings.legend, isVisible: legendVisible, position: legendPosition } }
                }
            };


        case ChartDesignerActionTypes.CHANGE_CHART_LABELONCHART:
            let labelFontOpen = state.config.publicSettings.labelOnChart.open
            let labelVisible = state.config.publicSettings.labelOnChart.isVisible
            let labelPosition = state.config.publicSettings.labelOnChart.position
            let labelfontFamily = state.config.publicSettings.labelOnChart.fontFamily
            let labelfontZaryb = state.config.publicSettings.labelOnChart.fontZaryb
            let labelfontFormat = state.config.publicSettings.labelOnChart.fontFormat
            let labelfontWeight = state.config.publicSettings.labelOnChart.fontWeight
            let labelfontStyle = state.config.publicSettings.labelOnChart.fontStyle
            let labelfontSize = state.config.publicSettings.labelOnChart.fontSize
            let labelTextAlign = state.config.publicSettings.labelOnChart.textAlign
            let labelColor = state.config.publicSettings.labelOnChart.color
            let labelBackgroundColor = state.config.publicSettings.labelOnChart.backgroundColor
            let labelRotate = state.config.publicSettings.labelOnChart.rotate
            let labelIsTotalShow = state.config.publicSettings.labelOnChart.isTotalShow
            let labelIsMatchColorWithArc = state.config.publicSettings.labelOnChart.isMatchColorWithArc


            let s_activeKey1 = state.config.publicSettings.activeKey

            if (action.payload.activeKey !== undefined) {
                s_activeKey1 = action.payload.activeKey
            }

            if (action.payload.isVisible !== undefined) {
                labelVisible = action.payload.isVisible
            }

            if (action.payload.open !== undefined) {
                labelFontOpen = action.payload.open
            }

            if (action.payload.position !== undefined)
                labelPosition = action.payload.position

            if (action.payload.fontFamily !== undefined)
                labelfontFamily = action.payload.fontFamily

            if (action.payload.fontZaryb !== undefined)
                labelfontZaryb = action.payload.fontZaryb

            if (action.payload.fontSize !== undefined)
                labelfontSize = action.payload.fontSize

            if (action.payload.fontFormat !== undefined)
                labelfontFormat = action.payload.fontFormat

            if (action.payload.color !== undefined)
                labelColor = action.payload.color

            if (action.payload.backgroundColor !== undefined)
                labelBackgroundColor = action.payload.backgroundColor

            if (action.payload.fontWeight !== undefined)
                labelfontWeight = action.payload.fontWeight

            if (action.payload.fontStyle !== undefined)
                labelfontStyle = action.payload.fontStyle

            if (action.payload.textAlign !== undefined)
                labelTextAlign = action.payload.textAlign

            if (action.payload.rotate !== undefined)
                labelRotate = action.payload.rotate

            if (action.payload.isTotalShow !== undefined)
                labelIsTotalShow = action.payload.isTotalShow

            if (action.payload.isMatchColorWithArc !== undefined)
                labelIsMatchColorWithArc = action.payload.isMatchColorWithArc



            return {
                ...state,
                config: {
                    ...state.config,
                    publicSettings: { ...state.config.publicSettings, activeKey: s_activeKey1, labelOnChart: { ...state.config.publicSettings.labelOnChart, open: labelFontOpen, isVisible: labelVisible, position: labelPosition, fontFamily: labelfontFamily, fontZaryb: labelfontZaryb, fontSize: labelfontSize, fontFormat: labelfontFormat, color: labelColor, backgroundColor: labelBackgroundColor, fontWeight: labelfontWeight, fontStyle: labelfontStyle, textAlign: labelTextAlign, rotate: labelRotate, isTotalShow: labelIsTotalShow, isMatchColorWithArc: labelIsMatchColorWithArc } }
                }
            };

        case ChartDesignerActionTypes.CHANGE_CHART_TABLESTYLE:
            let tableStyleheatmapMode = state.config.publicSettings.tableStyle.heatmapMode
            let tableStyleisRepeatKeysInGroups = state.config.publicSettings.tableStyle.isRepeatKeysInGroups
            let tableStyleisShowTotal = state.config.publicSettings.tableStyle.isShowTotal
            let tableStyleisShowTotalColumn = state.config.publicSettings.tableStyle.isShowTotalColumn
            let tableStyleFontOpen = state.config.publicSettings.tableStyle.open
            let tableStylefontFamily = state.config.publicSettings.tableStyle.fontFamily
            let tableStylefontZaryb = state.config.publicSettings.tableStyle.fontZaryb
            let tableStylefontFormat = state.config.publicSettings.tableStyle.fontFormat
            let tableStylefontWeight = state.config.publicSettings.tableStyle.fontWeight
            let tableStylefontStyle = state.config.publicSettings.tableStyle.fontStyle
            let tableStylefontSize = state.config.publicSettings.tableStyle.fontSize
            let tableStyleTextAlign = state.config.publicSettings.tableStyle.textAlign
            let tableStyleColor = state.config.publicSettings.tableStyle.color
            let tableStyleisShowSort = state.config.publicSettings.tableStyle.isShowSort
            let tableStyleisShowFilter = state.config.publicSettings.tableStyle.isShowFilter
            let tableStyleFontOpenSumSell = state.config.publicSettings.tableStyle.tableSumCellStyle.open
            let tableStylefontFamilySumSell = state.config.publicSettings.tableStyle.tableSumCellStyle.fontFamily
            let tableStylefontZarybSumSell = state.config.publicSettings.tableStyle.tableSumCellStyle.fontZaryb
            let tableStylefontFormatSumSell = state.config.publicSettings.tableStyle.tableSumCellStyle.fontFormat
            let tableStylefontWeightSumSell = state.config.publicSettings.tableStyle.tableSumCellStyle.fontWeight
            let tableStylefontStyleSumSell = state.config.publicSettings.tableStyle.tableSumCellStyle.fontStyle
            let tableStylefontSizeSumSell = state.config.publicSettings.tableStyle.tableSumCellStyle.fontSize
            let tableStyleTextAlignSumSell = state.config.publicSettings.tableStyle.tableSumCellStyle.textAlign
            let tableStyleColorSumSell = state.config.publicSettings.tableStyle.tableSumCellStyle.color
            let tableStyleFontOpenSumSellColumn = state.config.publicSettings.tableStyle.tableSumCellStyleColumn.open
            let tableStylefontFamilySumSellColumn = state.config.publicSettings.tableStyle.tableSumCellStyleColumn.fontFamily
            let tableStylefontZarybSumSellColumn = state.config.publicSettings.tableStyle.tableSumCellStyleColumn.fontZaryb
            let tableStylefontFormatSumSellColumn = state.config.publicSettings.tableStyle.tableSumCellStyleColumn.fontFormat
            let tableStylefontWeightSumSellColumn = state.config.publicSettings.tableStyle.tableSumCellStyleColumn.fontWeight
            let tableStylefontStyleSumSellColumn = state.config.publicSettings.tableStyle.tableSumCellStyleColumn.fontStyle
            let tableStylefontSizeSumSellColumn = state.config.publicSettings.tableStyle.tableSumCellStyleColumn.fontSize
            let tableStyleTextAlignSumSellColumn = state.config.publicSettings.tableStyle.tableSumCellStyleColumn.textAlign
            let tableStyleColorSumSellColumn = state.config.publicSettings.tableStyle.tableSumCellStyleColumn.color
            let s_activeKey8 = state.config.publicSettings.activeKey

            if (action.payload.activeKey !== undefined) {
                s_activeKey8 = action.payload.activeKey
            }


            if (action.payload.isShowFilter !== undefined) {
                tableStyleisShowFilter = action.payload.isShowFilter
            }

            if (action.payload.isShowSort !== undefined) {
                tableStyleisShowSort = action.payload.isShowSort
            }

            if (action.payload.heatmapMode !== undefined) {
                tableStyleheatmapMode = action.payload.heatmapMode
            }

            if (action.payload.isRepeatKeysInGroups !== undefined) {
                tableStyleisRepeatKeysInGroups = action.payload.isRepeatKeysInGroups
            }

            if (action.payload.isShowTotal !== undefined) {
                tableStyleisShowTotal = action.payload.isShowTotal
            }

            if (action.payload.isShowTotalColumn !== undefined) {
                tableStyleisShowTotalColumn = action.payload.isShowTotalColumn
            }

            if (action.payload.open !== undefined) {
                tableStyleFontOpen = action.payload.open
            }

            if (action.payload.fontFamily !== undefined)
                tableStylefontFamily = action.payload.fontFamily

            if (action.payload.fontZaryb !== undefined)
                tableStylefontZaryb = action.payload.fontZaryb

            if (action.payload.fontSize !== undefined)
                tableStylefontSize = action.payload.fontSize

            if (action.payload.fontFormat !== undefined)
                tableStylefontFormat = action.payload.fontFormat

            if (action.payload.color !== undefined)
                tableStyleColor = action.payload.color

            if (action.payload.fontWeight !== undefined)
                tableStylefontWeight = action.payload.fontWeight

            if (action.payload.fontStyle !== undefined)
                tableStylefontStyle = action.payload.fontStyle

            if (action.payload.textAlign !== undefined)
                tableStyleTextAlign = action.payload.textAlign

            if (action?.payload?.tableSumCellStyle?.open !== undefined) {
                tableStyleFontOpenSumSell = action?.payload?.tableSumCellStyle?.open
            }

            if (action?.payload?.tableSumCellStyle?.fontFamily !== undefined)
                tableStylefontFamilySumSell = action.payload.tableSumCellStyle.fontFamily

            if (action?.payload?.tableSumCellStyle?.fontZaryb !== undefined)
                tableStylefontZarybSumSell = action.payload.tableSumCellStyle.fontZaryb

            if (action?.payload?.tableSumCellStyle?.fontSize !== undefined)
                tableStylefontSizeSumSell = action.payload.tableSumCellStyle.fontSize

            if (action?.payload?.tableSumCellStyle?.fontFormat !== undefined)
                tableStylefontFormatSumSell = action.payload.tableSumCellStyle.fontFormat

            if (action?.payload?.tableSumCellStyle?.color !== undefined)
                tableStyleColorSumSell = action.payload.tableSumCellStyle.color

            if (action?.payload?.tableSumCellStyle?.fontWeight !== undefined)
                tableStylefontWeightSumSell = action.payload.tableSumCellStyle.fontWeight

            if (action?.payload?.tableSumCellStyle?.fontStyle !== undefined)
                tableStylefontStyleSumSell = action.payload.tableSumCellStyle.fontStyle

            if (action?.payload?.tableSumCellStyle?.textAlign !== undefined)
                tableStyleTextAlignSumSell = action.payload.tableSumCellStyle.textAlign

            if (action?.payload?.tableSumCellStyleColumn?.open !== undefined) {
                tableStyleFontOpenSumSellColumn = action?.payload?.tableSumCellStyleColumn?.open
            }
            if (action?.payload?.tableSumCellStyleColumn?.fontFamily !== undefined)
                tableStylefontFamilySumSellColumn = action.payload.tableSumCellStyleColumn.fontFamily

            if (action?.payload?.tableSumCellStyleColumn?.fontZaryb !== undefined)
                tableStylefontZarybSumSellColumn = action.payload.tableSumCellStyleColumn.fontZaryb

            if (action?.payload?.tableSumCellStyleColumn?.fontSize !== undefined)
                tableStylefontSizeSumSellColumn = action.payload.tableSumCellStyleColumn.fontSize

            if (action?.payload?.tableSumCellStyleColumn?.fontFormat !== undefined)
                tableStylefontFormatSumSellColumn = action.payload.tableSumCellStyleColumn.fontFormat

            if (action?.payload?.tableSumCellStyleColumn?.color !== undefined)
                tableStyleColorSumSellColumn = action.payload.tableSumCellStyleColumn.color

            if (action?.payload?.tableSumCellStyleColumn?.fontWeight !== undefined)
                tableStylefontWeightSumSellColumn = action.payload.tableSumCellStyleColumn.fontWeight

            if (action?.payload?.tableSumCellStyleColumn?.fontStyle !== undefined)
                tableStylefontStyleSumSellColumn = action.payload.tableSumCellStyleColumn.fontStyle

            if (action?.payload?.tableSumCellStyleColumn?.textAlign !== undefined)
                tableStyleTextAlignSumSellColumn = action.payload.tableSumCellStyleColumn.textAlign

            return {
                ...state,
                config: {
                    ...state.config,
                    publicSettings: {
                        ...state.config.publicSettings, activeKey: s_activeKey8, tableStyle: {
                            ...state.config.publicSettings.tableStyle, heatmapMode: tableStyleheatmapMode, isRepeatKeysInGroups: tableStyleisRepeatKeysInGroups, isShowTotal: tableStyleisShowTotal, isShowTotalColumn: tableStyleisShowTotalColumn, open: tableStyleFontOpen, fontFamily: tableStylefontFamily, fontZaryb: tableStylefontZaryb, fontSize: tableStylefontSize, fontFormat: tableStylefontFormat, color: tableStyleColor, fontWeight: tableStylefontWeight, fontStyle: tableStylefontStyle, textAlign: tableStyleTextAlign, isShowSort: tableStyleisShowSort, isShowFilter: tableStyleisShowFilter,
                            tableSumCellStyle: { open: tableStyleFontOpenSumSell, fontFamily: tableStylefontFamilySumSell, fontZaryb: tableStylefontZarybSumSell, fontSize: tableStylefontSizeSumSell, fontFormat: tableStylefontFormatSumSell, color: tableStyleColorSumSell, fontWeight: tableStylefontWeightSumSell, fontStyle: tableStylefontStyleSumSell, textAlign: tableStyleTextAlignSumSell }
                            , tableSumCellStyleColumn: { open: tableStyleFontOpenSumSellColumn, fontFamily: tableStylefontFamilySumSellColumn, fontZaryb: tableStylefontZarybSumSellColumn, fontSize: tableStylefontSizeSumSellColumn, fontFormat: tableStylefontFormatSumSellColumn, color: tableStyleColorSumSellColumn, fontWeight: tableStylefontWeightSumSellColumn, fontStyle: tableStylefontStyleSumSellColumn, textAlign: tableStyleTextAlignSumSellColumn }
                        }
                    }
                }
            };


        case ChartDesignerActionTypes.CHANGE_CHART_TOOLTIP:
            let tooltipVisible = state.config.publicSettings.tooltip.isVisible
            let tooltipShared = state.config.publicSettings.tooltip.isShared
            let tooltipFollow = state.config.publicSettings.tooltip.isFollow
            let tooltipFontOpen = state.config.publicSettings.tooltip.style.tooltip.open
            let tooltipFontFamily = state.config.publicSettings.tooltip.style.tooltip.fontFamily
            let tooltipFontZaryb = state.config.publicSettings.tooltip.style.tooltip.fontZaryb
            let tooltipFontFormat = state.config.publicSettings.tooltip.style.tooltip.fontFormat
            let tooltipFontSize = state.config.publicSettings.tooltip.style.tooltip.fontSize
            let tooltipBackgroundColor = state.config.publicSettings.tooltip.style.tooltip.backgroundColor
            let tooltipFontColor = state.config.publicSettings.tooltip.style.tooltip.fontColor
            let tooltipFontStyle = state.config.publicSettings.tooltip.style.tooltip.fontStyle
            let tooltipFontWeight = state.config.publicSettings.tooltip.style.tooltip.fontWeight
            let tooltipTextAlign = state.config.publicSettings.tooltip.style.tooltip.textAlign

            let tooltipActiveKey = state.config.publicSettings.activeKey

            if (action.payload.activeKey !== undefined) {
                tooltipActiveKey = action.payload.activeKey
            }

            if (action.payload.isVisible !== undefined) {
                tooltipVisible = action.payload.isVisible
            }

            if (action.payload.isShared !== undefined) {
                tooltipShared = action.payload.isShared
            }

            if (action.payload.isFollow !== undefined) {
                tooltipFollow = action.payload.isFollow
            }

            if (action.payload?.style?.tooltip?.fontFamily !== undefined) {
                tooltipFontFamily = action.payload.style.tooltip.fontFamily
            }

            if (action.payload?.style?.tooltip?.fontZaryb !== undefined) {
                tooltipFontZaryb = action.payload.style.tooltip.fontZaryb
            }

            if (action.payload?.style?.tooltip?.open !== undefined) {
                tooltipFontOpen = action.payload.style.tooltip.open
            }

            if (action.payload?.style?.tooltip?.fontSize !== undefined) {
                tooltipFontSize = action.payload.style.tooltip.fontSize
            }

            if (action.payload?.style?.tooltip?.fontFormat !== undefined) {
                tooltipFontFormat = action.payload.style.tooltip.fontFormat
            }

            if (action.payload?.style?.tooltip?.backgroundColor !== undefined) {
                tooltipBackgroundColor = action.payload.style.tooltip.backgroundColor
            }

            if (action.payload?.style?.tooltip?.fontColor !== undefined) {
                tooltipFontColor = action.payload.style.tooltip.fontColor
            }

            if (action.payload?.style?.tooltip?.fontStyle !== undefined) {
                tooltipFontStyle = action.payload.style.tooltip.fontStyle
            }

            if (action.payload?.style?.tooltip?.fontWeight !== undefined) {
                tooltipFontWeight = action.payload.style.tooltip.fontWeight
            }

            if (action.payload?.style?.tooltip?.textAlign !== undefined) {
                tooltipTextAlign = action.payload.style.tooltip.textAlign
            }


            return {
                ...state,
                config: {
                    ...state.config,
                    publicSettings: { ...state.config.publicSettings, activeKey: tooltipActiveKey, tooltip: { ...state.config.publicSettings.tooltip, isVisible: tooltipVisible, isShared: tooltipShared, isFollow: tooltipFollow, style: { ...state.config.publicSettings.tooltip.style, tooltip: { ...state.config.publicSettings.tooltip.style.tooltip, open: tooltipFontOpen, fontFamily: tooltipFontFamily, fontZaryb: tooltipFontZaryb, fontSize: tooltipFontSize, fontFormat: tooltipFontFormat, backgroundColor: tooltipBackgroundColor, fontColor: tooltipFontColor, fontStyle: tooltipFontStyle, fontWeight: tooltipFontWeight, textAlign: tooltipTextAlign } } } }
                }
            };

        case ChartDesignerActionTypes.CHANGE_CHART_LINE:
            let lineYFontOpen = state.config.publicSettings.line.lineY.style.open
            let lineYFontFamily = state.config.publicSettings.line.lineY.style.fontFamily
            let lineYFontZaryb = state.config.publicSettings.line.lineY.style.fontZaryb
            let lineYFontFormat = state.config.publicSettings.line.lineY.style.fontFormat
            let lineYFontSize = state.config.publicSettings.line.lineY.style.fontSize
            let lineYBackgroundColor = state.config.publicSettings.line.lineY.style.backgroundColor
            let lineYFontColor = state.config.publicSettings.line.lineY.style.fontColor
            let lineYFontStyle = state.config.publicSettings.line.lineY.style.fontStyle
            let lineYFontWeight = state.config.publicSettings.line.lineY.style.fontWeight
            let lineYTextAlign = state.config.publicSettings.line.lineY.style.textAlign
            let lineYAutoHide = state.config.publicSettings.line.lineY.autoHide
            let lineYAutoRotate = state.config.publicSettings.line.lineY.autoRotate
            let lineYIsScroll = state.config.publicSettings.line.lineY.isScroll
            let lineYMinLimit = state.config.publicSettings.line.lineY.minLimit
            let lineYMaxLimit = state.config.publicSettings.line.lineY.maxLimit
            let lineYRange = state.config.publicSettings.line.lineY.range

            let lineY2isVisible = state.config.publicSettings.line.lineY2.isVisible
            let lineY2FontOpen = state.config.publicSettings.line.lineY2.style.open
            let lineY2FontFamily = state.config.publicSettings.line.lineY2.style.fontFamily
            let lineY2FontZaryb = state.config.publicSettings.line.lineY2.style.fontZaryb
            let lineY2FontFormat = state.config.publicSettings.line.lineY2.style.fontFormat
            let lineY2FontSize = state.config.publicSettings.line.lineY2.style.fontSize
            let lineY2BackgroundColor = state.config.publicSettings.line.lineY2.style.backgroundColor
            let lineY2FontColor = state.config.publicSettings.line.lineY2.style.fontColor
            let lineY2FontStyle = state.config.publicSettings.line.lineY2.style.fontStyle
            let lineY2FontWeight = state.config.publicSettings.line.lineY2.style.fontWeight
            let lineY2TextAlign = state.config.publicSettings.line.lineY2.style.textAlign
            let lineY2AutoHide = state.config.publicSettings.line.lineY2.autoHide
            let lineY2AutoRotate = state.config.publicSettings.line.lineY2.autoRotate
            let lineY2IsScroll = state.config.publicSettings.line.lineY2.isScroll
            let lineY2MinLimit = state.config.publicSettings.line.lineY2.minLimit
            let lineY2MaxLimit = state.config.publicSettings.line.lineY2.maxLimit


            let lineActiveKey = state.config.publicSettings.activeKey

            let lineXFontOpen = state.config.publicSettings.line.lineX.style.open
            let lineXFontFamily = state.config.publicSettings.line.lineX.style.fontFamily
            let lineXFontZaryb = state.config.publicSettings.line.lineX.style.fontZaryb
            let lineXFontFormat = state.config.publicSettings.line.lineX.style.fontFormat
            let lineXFontSize = state.config.publicSettings.line.lineX.style.fontSize
            let lineXBackgroundColor = state.config.publicSettings.line.lineX.style.backgroundColor
            let lineXFontColor = state.config.publicSettings.line.lineX.style.fontColor
            let lineXFontStyle = state.config.publicSettings.line.lineX.style.fontStyle
            let lineXFontWeight = state.config.publicSettings.line.lineX.style.fontWeight
            let lineXTextAlign = state.config.publicSettings.line.lineX.style.textAlign
            let lineXAutoHide = state.config.publicSettings.line.lineX.autoHide
            let lineXAutoRotate = state.config.publicSettings.line.lineX.autoRotate
            let lineXIsScroll = state.config.publicSettings.line.lineX.isScroll
            let lineXMinLimit = state.config.publicSettings.line.lineX.minLimit
            let lineXMaxLimit = state.config.publicSettings.line.lineX.maxLimit
            let lineXIsSlider = state.config.publicSettings.line.lineX.isSlider
            let lineXRange = state.config.publicSettings.line.lineX.range


            if (action.payload.activeKey !== undefined) {
                lineActiveKey = action.payload.activeKey
            }

            if (action.payload?.lineY?.style?.fontFamily !== undefined) {
                lineYFontFamily = action.payload?.lineY?.style?.fontFamily
            }

            if (action.payload?.lineY?.style?.fontZaryb !== undefined) {
                lineYFontZaryb = action.payload?.lineY?.style?.fontZaryb
            }

            if (action.payload?.lineY?.style?.open !== undefined) {
                lineYFontOpen = action.payload?.lineY?.style.open
            }

            if (action.payload?.lineY?.style?.fontSize !== undefined) {
                lineYFontSize = action.payload?.lineY?.style?.fontSize
            }

            if (action.payload?.lineY?.style?.fontFormat !== undefined) {
                lineYFontFormat = action.payload?.lineY?.style?.fontFormat
            }

            if (action.payload?.lineY?.style?.backgroundColor !== undefined) {
                lineYBackgroundColor = action.payload?.lineY?.style?.backgroundColor
            }

            if (action.payload?.lineY?.style?.fontColor !== undefined) {
                lineYFontColor = action.payload?.lineY?.style?.fontColor
            }

            if (action.payload?.lineY?.style?.fontStyle !== undefined) {
                lineYFontStyle = action.payload?.lineY?.style?.fontStyle
            }

            if (action.payload?.lineY?.style?.fontWeight !== undefined) {
                lineYFontWeight = action.payload?.lineY?.style?.fontWeight
            }

            if (action.payload?.lineY?.style?.textAlign !== undefined) {
                lineYTextAlign = action.payload?.lineY?.style?.textAlign
            }

            if (action.payload?.lineY?.autoHide !== undefined) {
                lineYAutoHide = action.payload?.lineY?.autoHide
            }

            if (action.payload?.lineY?.autoRotate !== undefined) {
                lineYAutoRotate = action.payload?.lineY?.autoRotate
            }

            if (action.payload?.lineY?.isScroll !== undefined) {
                lineYIsScroll = action.payload?.lineY?.isScroll
            }

            if (action.payload?.lineY?.minLimit !== undefined) {
                lineYMinLimit = action.payload?.lineY?.minLimit
            }

            if (action.payload?.lineY?.maxLimit !== undefined) {
                lineYMaxLimit = action.payload?.lineY?.maxLimit
            }
            /////////
            if (action.payload?.lineY2?.style?.fontFamily !== undefined) {
                lineY2FontFamily = action.payload?.lineY2?.style?.fontFamily
            }

            if (action.payload?.lineY2?.style?.fontZaryb !== undefined) {
                lineY2FontZaryb = action.payload?.lineY2?.style?.fontZaryb
            }

            if (action.payload?.lineY2?.style?.open !== undefined) {
                lineY2FontOpen = action.payload?.lineY2?.style.open
            }

            if (action.payload?.lineY2?.style?.fontSize !== undefined) {
                lineY2FontSize = action.payload?.lineY2?.style?.fontSize
            }

            if (action.payload?.lineY2?.style?.fontFormat !== undefined) {
                lineY2FontFormat = action.payload?.lineY2?.style?.fontFormat
            }

            if (action.payload?.lineY2?.style?.backgroundColor !== undefined) {
                lineY2BackgroundColor = action.payload?.lineY2?.style?.backgroundColor
            }

            if (action.payload?.lineY2?.style?.fontColor !== undefined) {
                lineY2FontColor = action.payload?.lineY2?.style?.fontColor
            }

            if (action.payload?.lineY2?.style?.fontStyle !== undefined) {
                lineY2FontStyle = action.payload?.lineY2?.style?.fontStyle
            }

            if (action.payload?.lineY2?.style?.fontWeight !== undefined) {
                lineY2FontWeight = action.payload?.lineY2?.style?.fontWeight
            }

            if (action.payload?.lineY2?.style?.textAlign !== undefined) {
                lineY2TextAlign = action.payload?.lineY2?.style?.textAlign
            }

            if (action.payload?.lineY2?.autoHide !== undefined) {
                lineY2AutoHide = action.payload?.lineY2?.autoHide
            }

            if (action.payload?.lineY2?.autoRotate !== undefined) {
                lineY2AutoRotate = action.payload?.lineY2?.autoRotate
            }

            if (action.payload?.lineY2?.isScroll !== undefined) {
                lineY2IsScroll = action.payload?.lineY2?.isScroll
            }

            if (action.payload?.lineY2?.minLimit !== undefined) {
                lineY2MinLimit = action.payload?.lineY2?.minLimit
            }

            if (action.payload?.lineY2?.maxLimit !== undefined) {
                lineY2MaxLimit = action.payload?.lineY2?.maxLimit
            }

            if (action.payload?.lineY2?.isVisible !== undefined) {
                lineY2isVisible = action.payload?.lineY2?.isVisible
            }


            /////////            
            if (action.payload?.lineX?.style?.fontFamily !== undefined) {
                lineXFontFamily = action.payload?.lineX?.style?.fontFamily
            }

            if (action.payload?.lineX?.style?.fontZaryb !== undefined) {
                lineXFontZaryb = action.payload?.lineX?.style?.fontZaryb
            }

            if (action.payload?.lineX?.style?.open !== undefined) {
                lineXFontOpen = action.payload?.lineX?.style.open
            }

            if (action.payload?.lineX?.style?.fontSize !== undefined) {
                lineXFontSize = action.payload?.lineX?.style?.fontSize
            }

            if (action.payload?.lineX?.style?.fontFormat !== undefined) {
                lineXFontFormat = action.payload?.lineX?.style?.fontFormat
            }

            if (action.payload?.lineX?.style?.backgroundColor !== undefined) {
                lineXBackgroundColor = action.payload?.lineX?.style?.backgroundColor
            }

            if (action.payload?.lineX?.style?.fontColor !== undefined) {
                lineXFontColor = action.payload?.lineX?.style?.fontColor
            }

            if (action.payload?.lineX?.style?.fontStyle !== undefined) {
                lineXFontStyle = action.payload?.lineX?.style?.fontStyle
            }

            if (action.payload?.lineX?.style?.fontWeight !== undefined) {
                lineXFontWeight = action.payload?.lineX?.style?.fontWeight
            }

            if (action.payload?.lineX?.style?.textAlign !== undefined) {
                lineXTextAlign = action.payload?.lineX?.style?.textAlign
            }

            if (action.payload?.lineX?.autoHide !== undefined) {
                lineXAutoHide = action.payload?.lineX?.autoHide
            }

            if (action.payload?.lineX?.autoRotate !== undefined) {
                lineXAutoRotate = action.payload?.lineX?.autoRotate
            }

            if (action.payload?.lineX?.isScroll !== undefined) {
                lineXIsScroll = action.payload?.lineX?.isScroll
            }

            if (action.payload?.lineX?.minLimit !== undefined) {
                lineXMinLimit = action.payload?.lineX?.minLimit
            }

            if (action.payload?.lineX?.maxLimit !== undefined) {
                lineXMaxLimit = action.payload?.lineX?.maxLimit
            }

            if (action.payload?.lineX?.isSlider !== undefined) {
                lineXIsSlider = action.payload?.lineX?.isSlider
            }

            if (action.payload?.lineX?.range !== undefined) {
                lineXRange = action.payload?.lineX?.range
            }

            if (action.payload?.lineY?.range !== undefined) {
                lineYRange = action.payload?.lineY?.range
            }



            return {
                ...state,
                config: {
                    ...state.config,
                    publicSettings: {
                        ...state.config.publicSettings, activeKey: lineActiveKey, line:
                        {
                            ...state.config.publicSettings.line
                            , lineY: { ...state.config.publicSettings.line.lineY, range: lineYRange, autoHide: lineYAutoHide, autoRotate: lineYAutoRotate, isScroll: lineYIsScroll, minLimit: lineYMinLimit, maxLimit: lineYMaxLimit, style: { ...state.config.publicSettings.line.lineY.style, open: lineYFontOpen, fontFamily: lineYFontFamily, fontZaryb: lineYFontZaryb, fontSize: lineYFontSize, fontFormat: lineYFontFormat, backgroundColor: lineYBackgroundColor, fontColor: lineYFontColor, fontStyle: lineYFontStyle, fontWeight: lineYFontWeight, textAlign: lineYTextAlign } }
                            , lineY2: { ...state.config.publicSettings.line.lineY2, isVisible: lineY2isVisible, autoHide: lineY2AutoHide, autoRotate: lineY2AutoRotate, isScroll: lineY2IsScroll, minLimit: lineY2MinLimit, maxLimit: lineY2MaxLimit, style: { ...state.config.publicSettings.line.lineY2.style, open: lineY2FontOpen, fontFamily: lineY2FontFamily, fontZaryb: lineY2FontZaryb, fontSize: lineY2FontSize, fontFormat: lineY2FontFormat, backgroundColor: lineY2BackgroundColor, fontColor: lineY2FontColor, fontStyle: lineY2FontStyle, fontWeight: lineY2FontWeight, textAlign: lineY2TextAlign } }
                            , lineX: { ...state.config.publicSettings.line.lineX, range: lineXRange, autoHide: lineXAutoHide, autoRotate: lineXAutoRotate, isScroll: lineXIsScroll, minLimit: lineXMinLimit, maxLimit: lineXMaxLimit, isSlider: lineXIsSlider, style: { ...state.config.publicSettings.line.lineX.style, open: lineXFontOpen, fontFamily: lineXFontFamily, fontZaryb: lineXFontZaryb, fontSize: lineXFontSize, fontFormat: lineXFontFormat, backgroundColor: lineXBackgroundColor, fontColor: lineXFontColor, fontStyle: lineXFontStyle, fontWeight: lineXFontWeight, textAlign: lineXTextAlign } }
                        }
                    }
                }
            };

        case ChartDesignerActionTypes.CHANGE_CHART_RANGEMARKER:
            let lineRangeActiveKey = state.config.publicSettings.activeKey
            let lineRange = state.config.publicSettings.rangeMarker.range
            let lineMarker = state.config.publicSettings.rangeMarker.marker

            if (action.payload.activeKey !== undefined) {
                lineRangeActiveKey = action.payload.activeKey
            }

            if (action.payload?.range !== undefined) {
                lineRange = action.payload?.range
            }

            if (action.payload?.marker !== undefined) {
                lineMarker = action.payload?.marker
            }

            return {
                ...state,
                config: {
                    ...state.config,
                    publicSettings: {
                        ...state.config.publicSettings, activeKey: lineRangeActiveKey, rangeMarker:
                        {
                            ...state.config.publicSettings.rangeMarker,
                            range: lineRange,
                            marker: lineMarker
                        }
                    }
                }
            };


        case ChartDesignerActionTypes.CHANGE_CHART_WIDGET:
            let widgetVisible = state.config.publicSettings.widget.isVisible
            let widgetBackgroundColor = state.config.publicSettings.widget.style.backgroundColor

            let widgetTextLabelFontOpen = state.config.publicSettings.widget.style.textLabel.open
            let widgetTextLabelFontFamily = state.config.publicSettings.widget.style.textLabel.fontFamily
            let widgetTextLabelFontZaryb = state.config.publicSettings.widget.style.textLabel.fontZaryb
            let widgetTextLabelFontFormat = state.config.publicSettings.widget.style.textLabel.fontFormat
            let widgetTextLabelFontSize = state.config.publicSettings.widget.style.textLabel.fontSize
            let widgetTextLabelFontColor = state.config.publicSettings.widget.style.textLabel.fontColor
            let widgetTextLabelFontStyle = state.config.publicSettings.widget.style.textLabel.fontStyle
            let widgetTextLabelFontWeight = state.config.publicSettings.widget.style.textLabel.fontWeight
            let widgetTextLabelTextAlign = state.config.publicSettings.widget.style.textLabel.textAlign

            let widgetValueLabelFontOpen = state.config.publicSettings.widget.style.valueLabel.open
            let widgetValueLabelFontFamily = state.config.publicSettings.widget.style.valueLabel.fontFamily
            let widgetValueLabelFontZaryb = state.config.publicSettings.widget.style.valueLabel.fontZaryb
            let widgetValueLabelFontFormat = state.config.publicSettings.widget.style.valueLabel.fontFormat
            let widgetValueLabelFontSize = state.config.publicSettings.widget.style.valueLabel.fontSize
            let widgetValueLabelFontColor = state.config.publicSettings.widget.style.valueLabel.fontColor
            let widgetValueLabelFontStyle = state.config.publicSettings.widget.style.valueLabel.fontStyle
            let widgetValueLabelFontWeight = state.config.publicSettings.widget.style.valueLabel.fontWeight
            let widgetValueLabelTextAlign = state.config.publicSettings.widget.style.valueLabel.textAlign

            let widgetIconName = state.config.publicSettings.widget.icon.name
            let widgetIconSize = state.config.publicSettings.widget.icon.size
            let widgetIconColor = state.config.publicSettings.widget.icon.color
            let widgetIconIsFill = state.config.publicSettings.widget.icon.isFill



            let widgetActiveKey = state.config.publicSettings.activeKey

            if (action.payload.activeKey !== undefined) {
                widgetActiveKey = action.payload.activeKey
            }

            if (action.payload.isVisible !== undefined) {
                widgetVisible = action.payload.isVisible
            }

            if (action.payload?.icon?.name !== undefined) {
                widgetIconName = action.payload.icon.name
            }

            if (action.payload?.icon?.color !== undefined) {
                widgetIconColor = action.payload.icon.color
            }

            if (action.payload?.icon?.size !== undefined) {
                widgetIconSize = action.payload.icon.size
            }

            if (action.payload?.icon?.isFill !== undefined) {
                widgetIconIsFill = action.payload.icon.isFill
            }

            if (action.payload?.style?.textLabel?.fontFamily !== undefined) {
                widgetTextLabelFontFamily = action.payload.style.textLabel.fontFamily
            }

            if (action.payload?.style?.textLabel?.fontZaryb !== undefined) {
                widgetTextLabelFontZaryb = action.payload.style.textLabel.fontZaryb
            }

            if (action.payload?.style?.textLabel?.open !== undefined) {
                widgetTextLabelFontOpen = action.payload.style.textLabel.open
            }

            if (action.payload?.style?.textLabel?.fontSize !== undefined) {
                widgetTextLabelFontSize = action.payload.style.textLabel.fontSize
            }

            if (action.payload?.style?.textLabel?.fontFormat !== undefined) {
                widgetTextLabelFontFormat = action.payload.style.textLabel.fontFormat
            }

            if (action.payload?.style?.backgroundColor !== undefined) {
                widgetBackgroundColor = action.payload.style.backgroundColor
            }

            if (action.payload?.style?.textLabel?.fontColor !== undefined) {
                widgetTextLabelFontColor = action.payload.style.textLabel.fontColor
            }

            if (action.payload?.style?.textLabel?.fontStyle !== undefined) {
                widgetTextLabelFontStyle = action.payload.style.textLabel.fontStyle
            }

            if (action.payload?.style?.textLabel?.fontWeight !== undefined) {
                widgetTextLabelFontWeight = action.payload.style.textLabel.fontWeight
            }

            if (action.payload?.style?.textLabel?.textAlign !== undefined) {
                widgetTextLabelTextAlign = action.payload.style.textLabel.textAlign
            }

            ///////////////
            if (action.payload?.style?.valueLabel?.open !== undefined) {
                widgetValueLabelFontOpen = action.payload.style.valueLabel.open
            }

            if (action.payload?.style?.valueLabel?.fontFamily !== undefined) {
                widgetValueLabelFontFamily = action.payload.style.valueLabel.fontFamily
            }

            if (action.payload?.style?.valueLabel?.fontZaryb !== undefined) {
                widgetValueLabelFontZaryb = action.payload.style.valueLabel.fontZaryb
            }

            if (action.payload?.style?.valueLabel?.fontSize !== undefined) {
                widgetValueLabelFontSize = action.payload.style.valueLabel.fontSize
            }

            if (action.payload?.style?.valueLabel?.fontFormat !== undefined) {
                widgetValueLabelFontFormat = action.payload.style.valueLabel.fontFormat
            }

            if (action.payload?.style?.valueLabel?.fontColor !== undefined) {
                widgetValueLabelFontColor = action.payload.style.valueLabel.fontColor
            }

            if (action.payload?.style?.valueLabel?.fontStyle !== undefined) {
                widgetValueLabelFontStyle = action.payload.style.valueLabel.fontStyle
            }

            if (action.payload?.style?.valueLabel?.fontWeight !== undefined) {
                widgetValueLabelFontWeight = action.payload.style.valueLabel.fontWeight
            }

            if (action.payload?.style?.valueLabel?.textAlign !== undefined) {
                widgetValueLabelTextAlign = action.payload.style.valueLabel.textAlign
            }

            return {
                ...state,
                config: {
                    ...state.config,
                    publicSettings: {
                        ...state.config.publicSettings, activeKey: widgetActiveKey, isVisible: widgetVisible, widget: {
                            ...state.config.publicSettings.widget, style: {
                                ...state.config.publicSettings.widget.style,
                                backgroundColor: widgetBackgroundColor,
                                textLabel: { ...state.config.publicSettings.widget.style.textLabel, open: widgetTextLabelFontOpen, fontFamily: widgetTextLabelFontFamily, fontZaryb: widgetTextLabelFontZaryb, fontSize: widgetTextLabelFontSize, fontFormat: widgetTextLabelFontFormat, fontColor: widgetTextLabelFontColor, fontStyle: widgetTextLabelFontStyle, fontWeight: widgetTextLabelFontWeight, textAlign: widgetTextLabelTextAlign }
                                , valueLabel: { ...state.config.publicSettings.widget.style.valueLabel, open: widgetValueLabelFontOpen, fontFamily: widgetValueLabelFontFamily, fontZaryb: widgetValueLabelFontZaryb, fontSize: widgetValueLabelFontSize, fontFormat: widgetValueLabelFontFormat, fontColor: widgetValueLabelFontColor, fontStyle: widgetValueLabelFontStyle, fontWeight: widgetValueLabelFontWeight, textAlign: widgetValueLabelTextAlign }
                            },
                            icon: { ...state.config.publicSettings.widget.icon, name: widgetIconName, color: widgetIconColor, size: widgetIconSize, isFill: widgetIconIsFill }
                        }
                    }
                }
            };

        case ChartDesignerActionTypes.CHANGE_CHART_FUNNEL:
            let funnelVisible = state.config.publicSettings.funnel.isVisible
            let funnelisTransposed = state.config.publicSettings.funnel.isTransposed
            let funneldynamicHeight = state.config.publicSettings.funnel.dynamicHeight
            let funnelconversionTag = state.config.publicSettings.funnel.conversionTag

            let funnelActiveKey = state.config.publicSettings.activeKey

            if (action.payload.activeKey !== undefined) {
                funnelActiveKey = action.payload.activeKey
            }

            if (action.payload.isVisible !== undefined) {
                funnelVisible = action.payload.isVisible
            }

            if (action.payload.isTransposed !== undefined) {
                funnelisTransposed = action.payload.isTransposed
            }

            if (action.payload.dynamicHeight !== undefined) {
                funneldynamicHeight = action.payload.dynamicHeight
            }

            if (action.payload.conversionTag !== undefined) {
                funnelconversionTag = action.payload.conversionTag
            }




            return {
                ...state,
                config: {
                    ...state.config,
                    publicSettings: {
                        ...state.config.publicSettings, activeKey: funnelActiveKey, isVisible: funnelVisible, funnel: {
                            ...state.config.publicSettings.funnel, isTransposed: funnelisTransposed, dynamicHeight: funneldynamicHeight, conversionTag: funnelconversionTag
                        }
                    }
                }
            };


        case ChartDesignerActionTypes.CHANGE_CHART_TEXT:
            let textChartVisible = state.config.publicSettings.textChart.isVisible
            let textChartBackgroundColor = state.config.publicSettings.textChart.style.backgroundColor

            let textChartTitleIsVisible = state.config.publicSettings.textChart.title.isVisible
            let textChartTitleContent = state.config.publicSettings.textChart.title.content

            let textChartSubTitleIsVisible = state.config.publicSettings.textChart.subTitle.isVisible
            let textChartSubTitleContent = state.config.publicSettings.textChart.subTitle.content

            let textChartTitleFontOpen = state.config.publicSettings.textChart.title.style.open
            let textChartTitleFontFamily = state.config.publicSettings.textChart.title.style.fontFamily
            let textChartTitleFontZaryb = state.config.publicSettings.textChart.title.style.fontZaryb

            let textChartTitleFontFormat = state.config.publicSettings.textChart.title.style.fontFormat
            let textChartTitleFontSize = state.config.publicSettings.textChart.title.style.fontSize
            let textChartTitleFontColor = state.config.publicSettings.textChart.title.style.fontColor
            let textChartTitleFontStyle = state.config.publicSettings.textChart.title.style.fontStyle
            let textChartTitleFontWeight = state.config.publicSettings.textChart.title.style.fontWeight
            let textChartTitleTextAlign = state.config.publicSettings.textChart.title.style.textAlign

            let textChartSubTitleFontOpen = state.config.publicSettings.textChart.subTitle.style.open
            let textChartSubTitleFontFamily = state.config.publicSettings.textChart.subTitle.style.fontFamily
            let textChartSubTitleFontZaryb = state.config.publicSettings.textChart.subTitle.style.fontZaryb

            let textChartSubTitleFontFormat = state.config.publicSettings.textChart.subTitle.style.fontFormat
            let textChartSubTitleFontSize = state.config.publicSettings.textChart.subTitle.style.fontSize
            let textChartSubTitleFontColor = state.config.publicSettings.textChart.subTitle.style.fontColor
            let textChartSubTitleFontStyle = state.config.publicSettings.textChart.subTitle.style.fontStyle
            let textChartSubTitleFontWeight = state.config.publicSettings.textChart.subTitle.style.fontWeight
            let textChartSubTitleTextAlign = state.config.publicSettings.textChart.subTitle.style.textAlign





            let titleChartActiveKey = state.config.publicSettings.activeKey

            if (action.payload.activeKey !== undefined) {
                titleChartActiveKey = action.payload.activeKey
            }

            if (action.payload?.style?.backgroundColor !== undefined) {
                textChartBackgroundColor = action.payload.style.backgroundColor
            }

            if (action.payload?.title?.isVisible !== undefined) {
                textChartTitleIsVisible = action.payload.title?.isVisible
            }

            if (action.payload?.title?.content !== undefined) {
                textChartTitleContent = action.payload.title?.content
            }

            if (action.payload?.subTitle?.isVisible !== undefined) {
                textChartSubTitleIsVisible = action.payload.subTitle?.isVisible
            }

            if (action.payload?.subTitle?.content !== undefined) {
                textChartSubTitleContent = action.payload.subTitle?.content
            }


            if (action.payload?.title?.style?.fontFamily !== undefined) {
                textChartTitleFontFamily = action.payload?.title?.style?.fontFamily
            }

            if (action.payload?.title?.style?.fontZaryb !== undefined) {
                textChartTitleFontZaryb = action.payload?.title?.style?.fontZaryb
            }

            if (action.payload?.title?.style?.open !== undefined) {
                textChartTitleFontOpen = action.payload?.title?.style?.open
            }

            if (action.payload?.title?.style?.fontSize !== undefined) {
                textChartTitleFontSize = action.payload?.title?.style?.fontSize
            }

            if (action.payload?.title?.style?.fontFormat !== undefined) {
                textChartTitleFontFormat = action.payload?.title?.style?.fontFormat
            }

            if (action.payload?.title?.style?.fontColor !== undefined) {
                textChartTitleFontColor = action.payload?.title?.style?.fontColor
            }

            if (action.payload?.title?.style?.fontStyle !== undefined) {
                textChartTitleFontStyle = action.payload?.title?.style?.fontStyle
            }

            if (action.payload?.title?.style?.fontWeight !== undefined) {
                textChartTitleFontWeight = action.payload?.title?.style?.fontWeight
            }

            if (action.payload?.title?.style?.textAlign !== undefined) {
                textChartTitleTextAlign = action.payload?.title?.style?.textAlign
            }

            ///////////////
            if (action.payload?.subTitle?.style?.open !== undefined) {
                textChartSubTitleFontOpen = action.payload?.subTitle?.style?.open
            }

            if (action.payload?.subTitle?.style?.fontFamily !== undefined) {
                textChartSubTitleFontFamily = action.payload?.subTitle?.style?.fontFamily
            }

            if (action.payload?.subTitle?.style?.fontZaryb !== undefined) {
                textChartSubTitleFontZaryb = action.payload?.subTitle?.style?.fontZaryb
            }

            if (action.payload?.subTitle?.style?.fontSize !== undefined) {
                textChartSubTitleFontSize = action.payload?.subTitle?.style?.fontSize
            }

            if (action.payload?.subTitle?.style?.fontFormat !== undefined) {
                textChartSubTitleFontFormat = action.payload?.subTitle?.style?.fontFormat
            }

            if (action.payload?.subTitle?.style?.fontColor !== undefined) {
                textChartSubTitleFontColor = action.payload?.subTitle?.style?.fontColor
            }

            if (action.payload?.subTitle?.style?.fontStyle !== undefined) {
                textChartSubTitleFontStyle = action.payload?.subTitle?.style?.fontStyle
            }

            if (action.payload?.subTitle?.style?.fontWeight !== undefined) {
                textChartSubTitleFontWeight = action.payload?.subTitle?.style?.fontWeight
            }

            if (action.payload?.subTitle?.style?.textAlign !== undefined) {
                textChartSubTitleTextAlign = action.payload?.subTitle?.style?.textAlign
            }

            return {
                ...state,
                config: {
                    ...state.config,
                    publicSettings: {
                        ...state.config.publicSettings, activeKey: titleChartActiveKey, isVisible: textChartVisible, textChart: {
                            ...state.config.publicSettings.textChart,
                            title: { ...state.config.publicSettings.textChart.title, isVisible: textChartTitleIsVisible, content: textChartTitleContent, style: { ...state.config.publicSettings.textChart.title.style, open: textChartTitleFontOpen, fontFamily: textChartTitleFontFamily, fontZaryb: textChartTitleFontZaryb, fontSize: textChartTitleFontSize, fontFormat: textChartTitleFontFormat, fontColor: textChartTitleFontColor, fontStyle: textChartTitleFontStyle, fontWeight: textChartTitleFontWeight, textAlign: textChartTitleTextAlign } }
                            , subTitle: { ...state.config.publicSettings.textChart.subTitle, isVisible: textChartSubTitleIsVisible, content: textChartSubTitleContent, style: { ...state.config.publicSettings.textChart.subTitle.style, open: textChartSubTitleFontOpen, fontFamily: textChartSubTitleFontFamily, fontZaryb: textChartSubTitleFontZaryb, fontSize: textChartSubTitleFontSize, fontFormat: textChartSubTitleFontFormat, fontColor: textChartSubTitleFontColor, fontStyle: textChartSubTitleFontStyle, fontWeight: textChartSubTitleFontWeight, textAlign: textChartSubTitleTextAlign } }

                            , style: {
                                ...state.config.publicSettings.textChart.style,
                                backgroundColor: textChartBackgroundColor,
                            },

                        },
                    }
                }
            };

        case ChartDesignerActionTypes.CHANGE_CHART_GAUGE:

            let s_gaugeItemList = state.gaugeItemList;

            let s_viewLabelType = state.config.publicSettings.gauge.viewLabelType
            let s_chartGaugeType = state.config.publicSettings.gauge.chartGaugeType
            let s_pointerType = state.config.publicSettings.gauge.pointerType
            let s_isGradient = state.config.publicSettings.gauge.isGradient
            let s_isPaddingInRange = state.config.publicSettings.gauge.isPaddingInRange


            let s_isUsePalletColor = state.config.publicSettings.gauge.isUsePalletColor
            let s_isMetric = state.config.publicSettings.gauge.isMetric
            let s_minValueDefault = state.config.publicSettings.gauge.minValue.default
            let s_minValueFieldName = state.config.publicSettings.gauge.minValue.fieldName
            let s_minValueSelectPercent = state.config.publicSettings.gauge.minValue.selectPercent
            let s_minValueTooltip = state.config.publicSettings.gauge.minValue.tooltip.text


            let s_maxValueDefault = state.config.publicSettings.gauge.maxValue.default
            let s_maxValueFieldName = state.config.publicSettings.gauge.maxValue.fieldName
            let s_maxValueSelectPercent = state.config.publicSettings.gauge.maxValue.selectPercent
            let s_maxValueTooltip = state.config.publicSettings.gauge.maxValue.tooltip.text

            let s_maxValueColor = state.config.publicSettings.gauge.maxValue.color
            let s_maxValueIshowInGauge = state.config.publicSettings.gauge.maxValue.isShowInGauge


            let s_range = state.config.publicSettings.gauge.range

            let gaugeRangeFontOpen = state.config.publicSettings.gauge.rangeStyle.open
            let gaugeRangeFontFamily = state.config.publicSettings.gauge.rangeStyle.fontFamily
            let gaugeRangeFontZaryb = state.config.publicSettings.gauge.rangeStyle.fontZaryb

            let gaugeRangeFontFormat = state.config.publicSettings.gauge.rangeStyle.fontFormat
            let gaugeRangeFontSize = state.config.publicSettings.gauge.rangeStyle.fontSize
            let gaugeRangeFontColor = state.config.publicSettings.gauge.rangeStyle.fontColor
            let gaugeRangeFontStyle = state.config.publicSettings.gauge.rangeStyle.fontStyle
            let gaugeRangeFontWeight = state.config.publicSettings.gauge.rangeStyle.fontWeight
            let gaugeRangeTextAlign = state.config.publicSettings.gauge.rangeStyle.textAlign

            if (action.payload?.rangeStyle?.open !== undefined) {
                gaugeRangeFontOpen = action.payload?.rangeStyle?.open
            }

            if (action.payload?.rangeStyle?.fontFamily !== undefined) {
                gaugeRangeFontFamily = action.payload?.rangeStyle?.fontFamily
            }

            if (action.payload?.rangeStyle?.fontZaryb !== undefined) {
                gaugeRangeFontZaryb = action.payload?.rangeStyle?.fontZaryb
            }

            if (action.payload?.rangeStyle?.fontFormat !== undefined) {
                gaugeRangeFontFormat = action.payload?.rangeStyle?.fontFormat
            }

            if (action.payload?.rangeStyle?.fontSize !== undefined) {
                gaugeRangeFontSize = action.payload?.rangeStyle?.fontSize
            }

            if (action.payload?.rangeStyle?.fontColor !== undefined) {
                gaugeRangeFontColor = action.payload?.rangeStyle?.fontColor
            }

            if (action.payload?.rangeStyle?.fontStyle !== undefined) {
                gaugeRangeFontStyle = action.payload?.rangeStyle?.fontStyle
            }

            if (action.payload?.rangeStyle?.fontWeight !== undefined) {
                gaugeRangeFontWeight = action.payload?.rangeStyle?.fontWeight
            }

            if (action.payload?.rangeStyle?.textAlign !== undefined) {
                gaugeRangeTextAlign = action.payload?.rangeStyle?.textAlign
            }

            if (action.payload?.chartGaugeType !== undefined) {
                s_chartGaugeType = action.payload.chartGaugeType
            }

            if (action.payload?.viewLabelType !== undefined) {
                s_viewLabelType = action.payload.viewLabelType
            }



            if (action.payload?.pointerType !== undefined) {
                s_pointerType = action.payload.pointerType
            }

            if (action.payload?.isGradient !== undefined) {
                s_isGradient = action.payload.isGradient
            }

            if (action.payload?.isPaddingInRange !== undefined) {
                s_isPaddingInRange = action.payload.isPaddingInRange
            }



            if (action.payload?.isUsePalletColor !== undefined) {
                s_isUsePalletColor = action.payload.isUsePalletColor
            }

            if (action.payload?.isMetric !== undefined) {
                s_isMetric = action.payload.isMetric
            }



            if (action.payload?.minValue?.default !== undefined) {
                s_minValueDefault = action.payload.minValue?.default
            }

            if (action.payload?.minValue?.tooltip !== undefined) {
                s_minValueTooltip = action.payload.minValue?.tooltip
            }







            if (action.payload?.minValue?.fieldName !== undefined) {

                if (action.payload?.minValue?.fieldName === "") {
                    var s_indexf = s_gaugeItemList?.indexOf(s_minValueFieldName);
                    if (s_indexf !== -1) {
                        s_gaugeItemList.splice(s_indexf, 1);
                    }
                }

                if (action.payload?.minValue?.fieldName !== "") {
                    var s_gaugeItemList1 = s_gaugeItemList;
                    s_gaugeItemList = [...s_gaugeItemList1, action.payload?.minValue?.fieldName]
                }

                s_minValueFieldName = action.payload.minValue?.fieldName
            }

            if (action.payload?.maxValue?.selectPercent !== undefined) {
                s_maxValueSelectPercent = action.payload.maxValue?.selectPercent
            }

            if (action.payload?.minValue?.selectPercent !== undefined) {
                s_minValueSelectPercent = action.payload.minValue?.selectPercent
            }

            if (action.payload?.maxValue?.default !== undefined) {
                s_maxValueDefault = action.payload.maxValue?.default
            }

            if (action.payload?.maxValue?.tooltip !== undefined) {
                s_maxValueTooltip = action.payload.maxValue?.tooltip
            }

            if (action.payload?.maxValue?.color !== undefined) {
                s_maxValueColor = action.payload.maxValue?.color
            }

            if (action.payload?.maxValue?.isShowInGauge !== undefined) {
                s_maxValueIshowInGauge = action.payload.maxValue?.isShowInGauge
            }

            if (action.payload?.maxValue?.fieldName !== undefined) {

                if (action.payload?.maxValue?.fieldName === "") {
                    var s_indexfm = s_gaugeItemList?.indexOf(s_maxValueFieldName);
                    if (s_indexfm !== -1) {
                        s_gaugeItemList.splice(s_indexfm, 1);
                    }
                }

                if (action.payload?.maxValue?.fieldName !== "") {
                    var s_gaugeItemList2 = s_gaugeItemList;
                    s_gaugeItemList = [...s_gaugeItemList2, action.payload?.maxValue?.fieldName]
                }

                s_maxValueFieldName = action.payload.maxValue?.fieldName
            }


            if (action.payload?.range !== undefined) {
                s_range = action.payload.range

                action.payload.range.map((x: any) => {
                    if (x.fieldName !== "") {
                        var s_indexf = s_gaugeItemList?.indexOf(x.fieldName);
                        if (s_indexf === -1) {
                            var s_gaugeItemList3 = s_gaugeItemList;
                            s_gaugeItemList = [...s_gaugeItemList3, x.fieldName]
                        }
                    }
                })

            }

            return {
                ...state,
                // chartType: cc,
                gaugeItemList: s_gaugeItemList,
                config: {
                    ...state.config, publicSettings: {
                        ...state.config.publicSettings, gauge: {
                            ...state.config.publicSettings.gauge,
                            viewLabelType: s_viewLabelType,
                            chartGaugeType: s_chartGaugeType,
                            pointerType: s_pointerType,
                            isGradient: s_isGradient,
                            isPaddingInRange: s_isPaddingInRange,
                            isUsePalletColor: s_isUsePalletColor,
                            isMetric: s_isMetric,
                            minValue: { ...state.config.publicSettings.gauge.minValue, default: s_minValueDefault, selectPercent: s_minValueSelectPercent, fieldName: s_minValueFieldName, tooltip: { text: s_minValueTooltip } },
                            maxValue: { ...state.config.publicSettings.gauge.maxValue, default: s_maxValueDefault, selectPercent: s_maxValueSelectPercent, fieldName: s_maxValueFieldName, color: s_maxValueColor, isShowInGauge: s_maxValueIshowInGauge, tooltip: { text: s_maxValueTooltip } },
                            range: s_range,
                            rangeStyle: { ...state.config.publicSettings.gauge.rangeStyle, open: gaugeRangeFontOpen, fontFamily: gaugeRangeFontFamily, fontZaryb: gaugeRangeFontZaryb, fontSize: gaugeRangeFontSize, fontFormat: gaugeRangeFontFormat, fontColor: gaugeRangeFontColor, fontStyle: gaugeRangeFontStyle, fontWeight: gaugeRangeFontWeight, textAlign: gaugeRangeTextAlign },
                        }
                    }
                }
            };

        case ChartDesignerActionTypes.CHANGE_CHART_MAP:
            let s_chartMapType = state.config.publicSettings.map.chartMapType
            let s_isZoom = state.config.publicSettings.map.isZoom

            if (action.payload?.chartMapType !== undefined) {
                s_chartMapType = action.payload.chartMapType
            }

            if (action.payload?.isZoom !== undefined) {
                s_isZoom = action.payload.isZoom
            }

            return {
                ...state,
                config: {
                    ...state.config, publicSettings: {
                        ...state.config.publicSettings, map: {
                            ...state.config.publicSettings.map,
                            chartMapType: s_chartMapType,
                            isZoom: s_isZoom
                        }
                    }
                }
            };

        case ChartDesignerActionTypes.CHANGE_CHART_PIE:
            let s_chartPieType = state.config.publicSettings.pie.type
            let s_isPercent = state.config.publicSettings.pie.isPercent
            let s_isShowValue = state.config.publicSettings.pie.isShowValue

            let s_isVisibleShowTotal = state.config.publicSettings.pie.showTotal.isVisible


            if (action.payload?.type !== undefined) {
                s_chartPieType = action.payload.type
            }

            if (action.payload?.isPercent !== undefined) {
                s_isPercent = action.payload.isPercent
            }

            if (action.payload?.isShowValue !== undefined) {
                s_isShowValue = action.payload.isShowValue
            }

            if (action.payload?.showTotal?.isVisible !== undefined) {
                s_isVisibleShowTotal = action.payload?.showTotal?.isVisible
            }

            return {
                ...state,
                config: {
                    ...state.config, publicSettings: {
                        ...state.config.publicSettings, pie: {
                            ...state.config.publicSettings.pie,
                            type: s_chartPieType,
                            isPercent: s_isPercent,
                            isShowValue: s_isShowValue,
                            showTotal: {
                                ...state.config.publicSettings.pie.showTotal, isVisible: s_isVisibleShowTotal
                            }
                        }
                    }
                }
            };

        case ChartDesignerActionTypes.CHANGE_CHART_PICS:
            let s_picsFilePath = state.config.publicSettings.pics.filePath
            if (action.payload?.filePath !== undefined) {
                s_picsFilePath = action.payload.filePath
            }

            return {
                ...state,
                config: {
                    ...state.config, publicSettings: {
                        ...state.config.publicSettings, pics: {
                            ...state.config.publicSettings.pics,
                            filePath: s_picsFilePath,
                        }
                    }
                }
            };


        case ChartDesignerActionTypes.CHANGE_CHART_LINEAREA:
            let s_isSmooth = state.config.publicSettings.lineArea.isSmooth
            let s_SheklOnShekast = state.config.publicSettings.lineArea.sheklOnShekast
            let s_isSheklOnShekast = state.config.publicSettings.lineArea.isSheklOnShekast

            if (action.payload?.isSmooth !== undefined) {
                s_isSmooth = action.payload?.isSmooth
            }

            if (action.payload?.sheklOnShekast !== undefined) {
                s_SheklOnShekast = action.payload?.sheklOnShekast
            }

            if (action.payload?.isSheklOnShekast !== undefined) {
                s_isSheklOnShekast = action.payload?.isSheklOnShekast
            }

            return {
                ...state,
                config: {
                    ...state.config, publicSettings: {
                        ...state.config.publicSettings, lineArea: {
                            ...state.config.publicSettings.lineArea,
                            isSmooth: s_isSmooth,
                            sheklOnShekast: s_SheklOnShekast,
                            isSheklOnShekast: s_isSheklOnShekast
                        }
                    }
                }
            };



        case ChartDesignerActionTypes.CHANGE_CHART_SCATTER:
            let s_scatterItemList = state.scatterItemList;
            let s_shape = state.config.publicSettings.scatter.shape
            let s_colorField = state.config.publicSettings.scatter.colorField
            let s_sizeField = state.config.publicSettings.scatter.sizeField
            let s_xFieldScatter = state.config.publicSettings.scatter.xFieldScatter

            if (action.payload?.shape !== undefined) {
                s_shape = action.payload.shape
            }

            if (action.payload?.colorField !== undefined) {

                if (action.payload?.colorField === "") {
                    var s_indexfC = s_scatterItemList?.indexOf(s_colorField);
                    if (s_indexfC !== -1) {
                        s_scatterItemList.splice(s_indexfC, 1);
                    }
                }

                if (action.payload?.colorField !== "") {
                    var s_scatterItemList1 = s_scatterItemList;
                    s_scatterItemList = [...s_scatterItemList1, action.payload?.colorField]
                }

                s_colorField = action.payload?.colorField
            }

            if (action.payload?.sizeField !== undefined) {

                if (action.payload?.sizeField === "") {
                    var s_indexfSi = s_scatterItemList?.indexOf(s_sizeField);
                    if (s_indexfSi !== -1) {
                        s_scatterItemList.splice(s_indexfSi, 1);
                    }
                }

                if (action.payload?.sizeField !== "") {
                    var s_scatterItemList1Si = s_scatterItemList;
                    s_scatterItemList = [...s_scatterItemList1Si, action.payload?.sizeField]
                }

                s_sizeField = action.payload?.sizeField
            }

            if (action.payload?.xFieldScatter !== undefined) {

                if (action.payload?.xFieldScatter === "") {
                    var s_indexfSca = s_scatterItemList?.indexOf(s_xFieldScatter);
                    if (s_indexfSca !== -1) {
                        s_scatterItemList.splice(s_indexfSca, 1);
                    }
                }

                if (action.payload?.xFieldScatter !== "") {
                    var s_scatterItemList1FC = s_scatterItemList;
                    s_scatterItemList = [...s_scatterItemList1FC, action.payload?.xFieldScatter]
                }

                s_xFieldScatter = action.payload?.xFieldScatter
            }

            return {
                ...state,
                scatterItemList: s_scatterItemList,
                config: {
                    ...state.config, publicSettings: {
                        ...state.config.publicSettings, scatter: {
                            ...state.config.publicSettings.scatter,
                            shape: s_shape,
                            colorField: s_colorField,
                            sizeField: s_sizeField,
                            xFieldScatter: s_xFieldScatter
                        }
                    }
                }
            };


        case ChartDesignerActionTypes.CHANGE_CHART_GRIDLINE:
            let gridLineVisible = state.config.publicSettings.gridLine.isVisible
            let xGridLineVisible = state.config.publicSettings.gridLine.xAxis.isVisible
            let yGridLineVisible = state.config.publicSettings.gridLine.yAxis.isVisible
            let xGridLineisLineDash = state.config.publicSettings.gridLine.xAxis.isLineDash
            let yGridLineisLineDash = state.config.publicSettings.gridLine.yAxis.isLineDash
            let xGridLinestroke = state.config.publicSettings.gridLine.xAxis.stroke
            let yGridLinestroke = state.config.publicSettings.gridLine.yAxis.stroke
            let xGridLineisAlignTick = state.config.publicSettings.gridLine.xAxis.isAlignTick
            let yGridLineisAlignTick = state.config.publicSettings.gridLine.yAxis.isAlignTick
            let xGridLineLineWidth = state.config.publicSettings.gridLine.xAxis.lineWidth
            let yGridLineLineWidth = state.config.publicSettings.gridLine.yAxis.lineWidth

            let gridLineActiveKey = state.config.publicSettings.activeKey

            if (action.payload.activeKey !== undefined) {
                gridLineActiveKey = action.payload.activeKey
            }

            if (action.payload.isVisible !== undefined) {
                gridLineVisible = action.payload.isVisible
            }

            if (action.payload?.xAxis?.isVisible !== undefined) {
                xGridLineVisible = action.payload?.xAxis?.isVisible
            }

            if (action.payload?.yAxis?.isVisible !== undefined) {
                yGridLineVisible = action.payload?.yAxis?.isVisible
            }

            if (action.payload?.xAxis?.isLineDash !== undefined) {
                xGridLineisLineDash = action.payload?.xAxis?.isLineDash
            }

            if (action.payload?.yAxis?.isLineDash !== undefined) {
                yGridLineisLineDash = action.payload?.yAxis?.isLineDash
            }

            if (action.payload?.xAxis?.stroke !== undefined) {
                xGridLinestroke = action.payload?.xAxis?.stroke
            }

            if (action.payload?.yAxis?.stroke !== undefined) {
                yGridLinestroke = action.payload?.yAxis?.stroke
            }

            if (action.payload?.xAxis?.isAlignTick !== undefined) {
                xGridLineisAlignTick = action.payload?.xAxis?.isAlignTick
            }

            if (action.payload?.yAxis?.isAlignTick !== undefined) {
                yGridLineisAlignTick = action.payload?.yAxis?.isAlignTick
            }

            if (action.payload?.xAxis?.lineWidth !== undefined) {
                xGridLineLineWidth = action.payload?.xAxis?.lineWidth
            }

            if (action.payload?.yAxis?.lineWidth !== undefined) {
                yGridLineLineWidth = action.payload?.yAxis?.lineWidth
            }



            return {
                ...state,
                config: {
                    ...state.config,
                    publicSettings: {
                        ...state.config.publicSettings, activeKey: gridLineActiveKey,
                        gridLine: {
                            ...state.config.publicSettings.gridLine, isVisible: gridLineVisible,
                            xAxis: { ...state.config.publicSettings.gridLine.xAxis, isVisible: xGridLineVisible, stroke: xGridLinestroke, isLineDash: xGridLineisLineDash, isAlignTick: xGridLineisAlignTick, lineWidth: xGridLineLineWidth },
                            yAxis: { ...state.config.publicSettings.gridLine.yAxis, isVisible: yGridLineVisible, stroke: yGridLinestroke, isLineDash: yGridLineisLineDash, isAlignTick: yGridLineisAlignTick, lineWidth: yGridLineLineWidth }
                        }
                    }
                }
            };

        case ChartDesignerActionTypes.CHANGE_BOAD_SORT:
            const boadSortIndex = state.boadList.findIndex(object => { return object.id === action.payload.id })
            const s_boadSortList = state.boadList;
            if (boadSortIndex !== -1) {
                s_boadSortList[boadSortIndex].sortOrder = { ...s_boadSortList[boadSortIndex].sortOrder, isSorted: action.payload.isSorted, fieldName: action.payload.fieldName, type: action.payload.type, fieldType: action.payload.fieldType }
            }

            return {
                ...state,
                boadList: s_boadSortList,
            };

        case ChartDesignerActionTypes.CHANGE_SHAXES_SORT:
            const shaxesSortIndex = state.shaxesList.findIndex(object => { return object.id === action.payload.id })
            const s_shaxesSortList = state.shaxesList;
            if (shaxesSortIndex !== -1) {
                s_shaxesSortList[shaxesSortIndex].sortOrder = { ...s_shaxesSortList[shaxesSortIndex].sortOrder, isSorted: action.payload.isSorted, type: action.payload.type }
            }

            return {
                ...state,
                shaxesList: s_shaxesSortList,
            };



        case ChartDesignerActionTypes.CHANGE_ISSORTING:
            return {
                ...state,
                config: {
                    ...state.config
                    , sanjabProp: {
                        ...state.config.sanjabProp, isSorting: action.payload
                        // ,dimension: !action.payload ? 'dor' : state.boadList.length > 0 && _.lowerFirst(state.boadList[0].name),

                    }
                }
            };

        case ChartDesignerActionTypes.CHANGE_ISCONDITIONALLY:
            return {
                ...state,
                config: {
                    ...state.config
                    , sanjabProp: {
                        ...state.config.sanjabProp, isConditionally: action.payload
                    }
                }
            };

        case ChartDesignerActionTypes.CHANGE_ISALARM:
            return {
                ...state,
                config: {
                    ...state.config
                    , sanjabProp: {
                        ...state.config.sanjabProp, isAlarm: action.payload
                    }
                }
            };

        case ChartDesignerActionTypes.CHANGE_isDrillTrogh:
            return {
                ...state,
                config: {
                    ...state.config
                    , sanjabProp: {
                        ...state.config.sanjabProp, isDrillTrogh: action.payload
                    }
                }
            };

        case ChartDesignerActionTypes.CHANGE_DrillTroghItem:
            const s_boadDrillTroughList = state.boadList;
            action.payload?.boads?.map((b: any) => {
                const boadDrillTroughIndex = state.boadList.findIndex(object => { return object.id === b.id })

                if (boadDrillTroughIndex !== -1) {
                    s_boadDrillTroughList[boadDrillTroughIndex].drillPageId = b.drillPageId

                    //s_boadDrillTroughList[boadDrillTroughIndex].series=b?.series
                }
            }
            )

            if (action.payload?.series && action.payload?.series.length > 0) {
                action.payload?.series?.map((b: any) => {

                    const boadDrillTroughIndex = state.boadList.findIndex(object => { return object.id === b.boadId })

                    if (boadDrillTroughIndex !== -1) {
                        s_boadDrillTroughList[boadDrillTroughIndex].series = b.series
                    }
                }
                )
            }

            else
                s_boadDrillTroughList.map(s => s.series = [])
            return {
                ...state,
                s_boadList: s_boadDrillTroughList,
                config: { ...state.config, sanjabProp: { ...state.config.sanjabProp, chartDrillTroghPageId: action.payload?.chartDrillTroghPageId } }
            };


        case ChartDesignerActionTypes.CHANGE_SHAXES_CONDITIONALLITY:
            const shaxesConditionallityIndex = state.shaxesList.findIndex(object => { return object.id === action.payload.id })
            const s_shaxesConditionallityList = state.shaxesList;
            if (shaxesConditionallityIndex !== -1) {
                s_shaxesConditionallityList[shaxesConditionallityIndex].cond = { ...s_shaxesConditionallityList[shaxesConditionallityIndex].conditionallity, type: action.payload.type, detail: action.payload.detail }
            }

            return {
                ...state,
                shaxesList: s_shaxesConditionallityList,
            };

        case ChartDesignerActionTypes.CHANGE_TABLE_CONDITIONALLITY:
            return {
                ...state,
                config: { ...state.config, sanjabProp: { ...state.config.sanjabProp, cond: action.payload } }
            };

        case ChartDesignerActionTypes.CHANGE_ALARM:
            // const shaxesConditionallityIndex = state.shaxesList.findIndex(object => { return object.id === action.payload.id })
            // const s_shaxesConditionallityList = state.shaxesList;
            // if (shaxesConditionallityIndex !== -1) {
            //     s_shaxesConditionallityList[shaxesConditionallityIndex].cond = { ...s_shaxesConditionallityList[shaxesConditionallityIndex].conditionallity, type: action.payload.type, detail: action.payload.detail }
            // }
console.log('action.payload:',action.payload)
            return {
                ...state,
                 alarms: action.payload,
            };

        case ChartDesignerActionTypes.CHANGE_ISCHANGESHAXES:

            const isChangeShaxes = state.config.sanjabProp.isChangeShaxes

            return {
                ...state,
                config: {
                    ...state.config,
                    sanjabProp: { ...state.config.sanjabProp, isChangeShaxes: !isChangeShaxes },
                }
            };


        case ChartDesignerActionTypes.CHANGE_BOAD_FILTER:
            const isFilterChange = state.config.sanjabProp.isChangeShaxes
            const boadIndex = state.boadList.findIndex(object => { return object.id === action.payload.id })
            const s_boadList = state.boadList;
            if (boadIndex !== -1) {
                //s_boadList[boadIndex].filter.filterList = action.payload.filterList;
                s_boadList[boadIndex].filter = { ...s_boadList[boadIndex].filter, filterList: action.payload.filterList }
            }
            //var t = renameDuplicate(s_boadList);

            return {
                ...state,
                boadList: s_boadList,
                config: {
                    ...state.config,
                    sanjabProp: { ...state.config.sanjabProp, isChangeShaxes: !isFilterChange },
                    //shaxesSettings: { ...state.config.shaxesSettings, activeKey: s_activeKey33 }
                }
            };


        case ChartDesignerActionTypes.CHANGE_SHAXES_FILTER:
            const isShaxesFilterChange = state.config.sanjabProp.isChangeShaxes
            const shaxesIndex = state.shaxesList.findIndex(object => { return object.id === action.payload.id })
            const s_shaxesList = state.shaxesList;
            if (shaxesIndex !== -1) {
                // s_shaxesList[shaxesIndex].filter.filterList = action.payload.filterList;
                s_shaxesList[shaxesIndex].filter = { ...s_shaxesList[shaxesIndex].filter, filterList: action.payload.filterList }

            }
            //var t = renameDuplicate(s_boadList);

            return {
                ...state,
                shaxesList: s_shaxesList,
                config: {
                    ...state.config,
                    sanjabProp: { ...state.config.sanjabProp, isChangeShaxes: !isShaxesFilterChange },
                    //shaxesSettings: { ...state.config.shaxesSettings, activeKey: s_activeKey33 }
                }
            };

        case ChartDesignerActionTypes.CHANGE_CONDITION_FILTER:
            const isConditionFilterChange = state.config.sanjabProp.isChangeShaxes
            const conditionIndex = state.conditionList.findIndex(object => { return object.id === action.payload.id })
            const s_conditionList = state.conditionList;
            if (conditionIndex !== -1) {
                // s_conditionList[conditionIndex].filter.filterList = action.payload.filterList;
                s_conditionList[conditionIndex].filter = { ...s_conditionList[conditionIndex].filter, filterList: action.payload.filterList }
            }
            //var t = renameDuplicate(s_boadList);

            return {
                ...state,
                conditionList: s_conditionList,
                config: {
                    ...state.config,
                    sanjabProp: { ...state.config.sanjabProp, isChangeShaxes: !isConditionFilterChange },
                    //shaxesSettings: { ...state.config.shaxesSettings, activeKey: s_activeKey33 }
                }
            };

        case ChartDesignerActionTypes.CHANGE_BOAD_FILTERCRITERIA:
            const isFilterCriteriaChange = state.config.sanjabProp.isChangeShaxes
            const s_boadIndex = state.boadList.findIndex(object => { return object.id === action.payload.id })
            const s_boadListC = state.boadList;
            if (s_boadIndex !== -1) {
                // s_boadListC[s_boadIndex].filter.filterCritria = action.payload.filterQC;
                s_boadListC[s_boadIndex].filter = { ...s_boadListC[s_boadIndex].filter, filterCriteria: action.payload.filterCriteria }

            }
            //var t = renameDuplicate(s_boadList);
            return {
                ...state,
                boadList: s_boadListC,
                config: {
                    ...state.config,
                    sanjabProp: { ...state.config.sanjabProp, isChangeShaxes: !isFilterCriteriaChange },
                    //shaxesSettings: { ...state.config.shaxesSettings, activeKey: s_activeKey33 }
                }
            };

        case ChartDesignerActionTypes.CHANGE_BOAD_FILTERGVARIABLE:
            const isFilterGVariableChange = state.config.sanjabProp.isChangeShaxes
            const s_boadGVIndex = state.boadList.findIndex(object => { return object.id === action.payload.id })
            const s_boadListGV = state.boadList;
            if (s_boadGVIndex !== -1) {
                // s_boadListC[s_boadIndex].filter.filterCritria = action.payload.filterQC;
                s_boadListGV[s_boadGVIndex].filter = { ...s_boadListGV[s_boadGVIndex].filter, filterGVariable: action.payload.filterGVariable }

            }
            //var t = renameDuplicate(s_boadList);
            return {
                ...state,
                boadList: s_boadListGV,
                config: {
                    ...state.config,
                    sanjabProp: { ...state.config.sanjabProp, isChangeShaxes: !isFilterGVariableChange },
                    //shaxesSettings: { ...state.config.shaxesSettings, activeKey: s_activeKey33 }
                }
            };


        case ChartDesignerActionTypes.CHANGE_SHAXES_FILTERCRITERIA:
            const isShaxesFilterCriteriaChange = state.config.sanjabProp.isChangeShaxes
            const s_shaxesIndex = state.shaxesList.findIndex(object => { return object.id === action.payload.id })
            const s_shaxesListC = state.shaxesList;
            if (s_shaxesIndex !== -1) {
                // s_boadListC[s_boadIndex].filter.filterCritria = action.payload.filterQC;
                s_shaxesListC[s_shaxesIndex].filter = { ...s_shaxesListC[s_shaxesIndex].filter, filterCriteria: action.payload.filterCriteria }

            }
            //var t = renameDuplicate(s_boadList);
            return {
                ...state,
                shaxesList: s_shaxesListC,
                config: {
                    ...state.config,
                    sanjabProp: { ...state.config.sanjabProp, isChangeShaxes: !isShaxesFilterCriteriaChange },
                    //shaxesSettings: { ...state.config.shaxesSettings, activeKey: s_activeKey33 }
                }
            };

        case ChartDesignerActionTypes.CHANGE_CONDITION_FILTERCRITERIA:
            const isConditionFilterCriteriaChange = state.config.sanjabProp.isChangeShaxes
            const s_conditionIndex = state.conditionList.findIndex(object => { return object.id === action.payload.id })
            const s_conditionListC = state.conditionList;
            if (s_conditionIndex !== -1) {
                // s_boadListC[s_boadIndex].filter.filterCritria = action.payload.filterQC;
                s_conditionListC[s_conditionIndex].filter = { ...s_conditionListC[s_conditionIndex].filter, filterCriteria: action.payload.filterCriteria }

            }
            //var t = renameDuplicate(s_boadList);
            return {
                ...state,
                conditionList: s_conditionListC,
                config: {
                    ...state.config,
                    sanjabProp: { ...state.config.sanjabProp, isChangeShaxes: !isConditionFilterCriteriaChange },
                    //shaxesSettings: { ...state.config.shaxesSettings, activeKey: s_activeKey33 }
                }
            };

        case ChartDesignerActionTypes.CHANGE_CONDITION_FILTERGVARIABLE:
            const isConditionFilterGVChange = state.config.sanjabProp.isChangeShaxes
            const s_conditionIndexGV = state.conditionList.findIndex(object => { return object.id === action.payload.id })
            const s_conditionListGV = state.conditionList;
            if (s_conditionIndexGV !== -1) {
                // s_boadListC[s_boadIndex].filter.filterCritria = action.payload.filterQC;
                s_conditionListGV[s_conditionIndexGV].filter = { ...s_conditionListGV[s_conditionIndexGV].filter, filterGVariable: action.payload.filterGVariable }

            }
            //var t = renameDuplicate(s_boadList);
            return {
                ...state,
                conditionList: s_conditionListGV,
                config: {
                    ...state.config,
                    sanjabProp: { ...state.config.sanjabProp, isChangeShaxes: !isConditionFilterGVChange },
                    //shaxesSettings: { ...state.config.shaxesSettings, activeKey: s_activeKey33 }
                }
            };


        case ChartDesignerActionTypes.CHANGE_SHAXES_FILTERAGGREGATION:
            const isShaxesFilterAggregationChange = state.config.sanjabProp.isChangeShaxes
            const s_shaxesAIndex = state.shaxesList.findIndex(object => { return object.id === action.payload.id })
            const s_shaxesListA = state.shaxesList;
            if (s_shaxesAIndex !== -1) {
                // s_boadListC[s_boadIndex].filter.filterCritria = action.payload.filterQC;
                s_shaxesListA[s_shaxesAIndex].filter = { ...s_shaxesListA[s_shaxesAIndex].filter, filterAggregation: action.payload.filterCriteria }

            }
            //var t = renameDuplicate(s_boadList);
            return {
                ...state,
                shaxesList: s_shaxesListA,
                config: {
                    ...state.config,
                    sanjabProp: { ...state.config.sanjabProp, isChangeShaxes: !isShaxesFilterAggregationChange },
                    //shaxesSettings: { ...state.config.shaxesSettings, activeKey: s_activeKey33 }
                }
            };

        default:
            return state;
    }
};

export default ChartDesign;
